<template>
  <div class="zy-box zy-box-diff1">
    <Breadcrumb></Breadcrumb>
    <el-row class="zy-school" id="zy-box" type="flex" justify="space-between">
      <el-col :span="16" style="margin-top: 24px">
        <div>
          <el-tabs
            v-model="selectType"
            type="border-card"
            slot="content"
            @tab-click="handleChangeCard"
            :class="selectType != '1' ? 'zytb-school-major-diff' : ''"
          >
            <el-tab-pane
              :name="card.type"
              :label="card.name + card.count + '所'"
              v-for="(card, index) in cardList"
              :key="index"
            >
            </el-tab-pane>
          </el-tabs>
          <div class="rank-box zy-list">
            <el-row>
              <el-col :span="24">
                <el-row class="zy-search">
                  <el-col
                    :span="4"
                    @mouseenter.native="hoverMenuHandler()"
                    @mouseleave.native="hoverMenuHandler()"
                  >
                    {{ typeMoreList[activeMoreIndex].name
                    }}<span
                      class="el-icon-arrow-down"
                      v-if="!hoverMenuStatus"
                    ></span
                    ><span class="el-icon-arrow-up" v-else></span>
                    <ul class="menu-tools-ul" v-if="hoverMenuStatus">
                      <li
                        @click.stop="changeSearchTypeHandler(index)"
                        v-for="(item, index) in typeMoreList"
                        :key="index"
                      >
                        {{ item.name }}
                      </li>
                    </ul>
                  </el-col>
                  <el-col :span="20">
                    <el-select
                      v-model="valueSchool"
                      multiple
                      filterable
                      remote
                      :remote-method="getSearchSchoolListHandler"
                      :loading="loading"
                      reserve-keyword
                      placeholder="请输入学校"
                      v-if="activeMoreIndex == 0"
                    >
                      <el-option
                        v-for="item in optionsSchool"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                    <img
                      src="../../assets/images/sousuo.png"
                      alt="搜索"
                      @click="resetGetSchoolListHandler"
                      @mouseenter="isShowSearch = !isShowSearch"
                      @mouseleave="isShowSearch = !isShowSearch"
                      v-if="!isShowSearch"
                    />
                    <img
                      src="../../assets/images/sousuo-diff.png"
                      alt="搜索"
                      @click="resetGetSchoolListHandler"
                      @mouseenter="isShowSearch = !isShowSearch"
                      @mouseleave="isShowSearch = !isShowSearch"
                      v-if="isShowSearch"
                    />
                    <el-select
                      v-model="valueMajor"
                      multiple
                      filterable
                      remote
                      :remote-method="geSearchSpecialListHandler"
                      placeholder="请输入专业"
                      v-if="activeMoreIndex == 1"
                    >
                      <el-option
                        v-for="item in optionsMajor"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                    <img
                      src="../../assets/images/sousuo.png"
                      alt="搜索"
                      @click="resetGetSchoolListHandler"
                      @mouseenter="isShowSearch1 = !isShowSearch1"
                      @mouseleave="isShowSearch1 = !isShowSearch1"
                      v-if="!isShowSearch1"
                    />
                    <img
                      src="../../assets/images/sousuo-diff.png"
                      alt="搜索"
                      @click="resetGetSchoolListHandler"
                      @mouseenter="isShowSearch1 = !isShowSearch1"
                      @mouseleave="isShowSearch1 = !isShowSearch1"
                      v-if="isShowSearch1"
                    />
                    <el-select
                      v-model="valueJob"
                      multiple
                      filterable
                      remote
                      :remote-method="getSearchJobListHandler"
                      placeholder="请输入职业"
                      v-if="activeMoreIndex == 2"
                    >
                      <el-option
                        v-for="item in optionsJob"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                    <img
                      src="../../assets/images/sousuo.png"
                      alt="搜索"
                      @click="resetGetSchoolListHandler"
                      @mouseenter="isShowSearch2 = !isShowSearch2"
                      @mouseleave="isShowSearch2 = !isShowSearch2"
                      v-if="!isShowSearch2"
                    />
                    <img
                      src="../../assets/images/sousuo-diff.png"
                      alt="搜索"
                      @click="resetGetSchoolListHandler"
                      @mouseenter="isShowSearch2 = !isShowSearch2"
                      @mouseleave="isShowSearch2 = !isShowSearch2"
                      v-if="isShowSearch2"
                    />
                  </el-col>
                </el-row>
              </el-col>
            </el-row>

            <div class="batch-search-list">
              <div class="province-list cascader-diff">
                <div class="title-box">选择省市：</div>
                <el-cascader
                  style="width: 230px"
                  :options="provinceList"
                  :props="props"
                  collapse-tags
                  clearable
                  @change="activeTagHandler"
                  popper-class="zhiyuan-cascader"
                >
                </el-cascader>
                <div class="title-box" style="margin-left: 24px">
                  选择专业：
                </div>
                <el-cascader
                  style="width: 230px"
                  :options="maList"
                  :props="{
                    multiple: true,
                    value: 'code',
                    label: 'name',
                    lazy: true,
                    lazyLoad: getMajorsHandler2,
                    emitPath: false,
                  }"
                  collapse-tags
                  clearable
                  @change="activeMaHandler"
                  popper-class="zhiyuan-cascader"
                >
                  <template slot-scope="{ data }">
                    <span v-if="data.name == '热门'">
                      {{ data.name }}
                      <img
                        src="@/assets/images/fire1.png"
                        alt="热门"
                        style="width: 10px; position: relative; top: 2px"
                      />
                    </span>
                    <span v-else>
                      {{ data.name }}
                    </span>
                  </template>
                </el-cascader>
              </div>
              <div class="province-list">
                <div class="title-box">院校类型：</div>
                <ContentLoader
                  primaryColor="#f0f2f5"
                  secondaryColor="#EFEFEF"
                  :base-url="$route.fullPath"
                  :animate="false"
                  :speed="0"
                  height="56"
                  width="670"
                  viewBox="0 0 670 56"
                  v-if="typeList.length == 1"
                >
                  <rect x="10" y="0" width="670" height="20" />
                  <rect x="10" y="30" width="670" height="20" />
                </ContentLoader>
                <div class="province-name" v-else>
                  <a
                    v-for="(item, index) in typeList"
                    :key="index"
                    :class="item.flag ? 'active-tag' : ''"
                    @click="activeTagHandler1(item, index)"
                    >{{ item.dic_value }}</a
                  >
                </div>
              </div>
              <template v-if="showSearchAll">
                <div class="province-list">
                  <div class="title-box">城市等级：</div>
                  <ContentLoader
                    primaryColor="#f0f2f5"
                    secondaryColor="#EFEFEF"
                    :base-url="$route.fullPath"
                    :animate="false"
                    :speed="0"
                    height="30"
                    width="670"
                    viewBox="0 0 670 30"
                    v-if="typeList10.length == 1"
                  >
                    <rect x="10" y="0" width="70" height="20" />
                  </ContentLoader>
                  <div class="province-name" v-else>
                    <a
                      v-for="(item, index) in typeList10"
                      :class="item.flag ? 'active-tag' : ''"
                      @click="activeTagHandler5(item,index)"
                      :key="index"
                      >{{ item.dic_value }}</a
                    >
                  </div>
                </div>
                <div class="province-list">
                  <div class="title-box">学费：</div>
                  <ContentLoader
                    primaryColor="#f0f2f5"
                    secondaryColor="#EFEFEF"
                    :base-url="$route.fullPath"
                    :animate="false"
                    :speed="0"
                    height="30"
                    width="670"
                    viewBox="0 0 670 30"
                    v-if="typeList9.length == 1"
                  >
                    <rect x="10" y="0" width="70" height="20" />
                  </ContentLoader>
                  <div class="province-name" v-else>
                    <a
                      v-for="(item, index) in typeList9"
                      :class="item.flag ? 'active-tag' : ''"
                      @click="activeTagHandler6(item,index)"
                      :key="index"
                      >{{ item.dic_value }}</a
                    >
                  </div>
                </div>
                <div class="province-list">
                  <div class="title-box">办学类型：</div>
                  <ContentLoader
                    primaryColor="#f0f2f5"
                    secondaryColor="#EFEFEF"
                    :base-url="$route.fullPath"
                    :animate="false"
                    :speed="0"
                    height="30"
                    width="670"
                    viewBox="0 0 670 30"
                    v-if="typeList1.length == 1"
                  >
                    <rect x="10" y="0" width="70" height="20" />
                  </ContentLoader>
                  <div class="province-name" v-else>
                    <a
                      v-for="(item, index) in typeList1"
                      :class="activeTag2 == index ? 'active-tag' : ''"
                      @click="activeTagHandler2(index)"
                      :key="index"
                      >{{ item.dic_value }}</a
                    >
                  </div>
                </div>
                <div class="province-list">
                  <div class="title-box">院校层次：</div>
                  <ContentLoader
                    primaryColor="#f0f2f5"
                    secondaryColor="#EFEFEF"
                    :base-url="$route.fullPath"
                    height="56"
                    width="670"
                    viewBox="0 0 670 56"
                    v-if="typeList6.length == 1"
                  >
                    <rect x="10" y="0" width="670" height="20" />
                    <rect x="10" y="30" width="670" height="20" />
                  </ContentLoader>
                  <div class="province-name" v-else>
                    <a
                      v-for="(item, index) in typeList6"
                      :key="'id1' + index"
                      :class="item.flag ? 'active-tag' : ''"
                      @click="activeTagHandler7(item, index)"
                      >{{ item.dic_value }}</a
                    >
                  </div>
                </div>
                <div class="province-list">
                  <div class="title-box">硕博点：</div>
                  <ContentLoader
                    primaryColor="#f0f2f5"
                    secondaryColor="#EFEFEF"
                    :base-url="$route.fullPath"
                    height="56"
                    width="670"
                    viewBox="0 0 670 56"
                    v-if="typeList7.length == 1"
                  >
                    <rect x="10" y="0" width="670" height="20" />
                    <rect x="10" y="30" width="670" height="20" />
                  </ContentLoader>
                  <div class="province-name" v-else>
                    <a
                      v-for="(item, index) in typeList7"
                      :key="'id1' + index"
                      :class="activeTag8 == index ? 'active-tag' : ''"
                      @click="activeTagHandler8(index)"
                      >{{ item.dic_value }}</a
                    >
                  </div>
                </div>
                <div class="province-list">
                  <div class="title-box">博士生点：</div>
                  <ContentLoader
                    primaryColor="#f0f2f5"
                    secondaryColor="#EFEFEF"
                    :base-url="$route.fullPath"
                    height="56"
                    width="670"
                    viewBox="0 0 670 56"
                    v-if="typeList8.length == 1"
                  >
                    <rect x="10" y="0" width="670" height="20" />
                    <rect x="10" y="30" width="670" height="20" />
                  </ContentLoader>
                  <div class="province-name" v-else>
                    <a
                      v-for="(item, index) in typeList8"
                      :key="'id1' + index"
                      :class="activeTag9 == index ? 'active-tag' : ''"
                      @click="activeTagHandler9(index)"
                      >{{ item.dic_value }}</a
                    >
                  </div>
                </div>
                <div class="province-list">
                  <div class="title-box">录取概率：</div>
                  <ContentLoader
                    primaryColor="#f0f2f5"
                    secondaryColor="#EFEFEF"
                    :base-url="$route.fullPath"
                    :animate="false"
                    :speed="0"
                    height="56"
                    width="670"
                    viewBox="0 0 670 56"
                    v-if="typeList.length == 1"
                  >
                    <rect x="10" y="0" width="670" height="20" />
                    <rect x="10" y="30" width="670" height="20" />
                  </ContentLoader>
                  <div class="province-name" v-else>
                    <a
                      v-for="(item, index) in typeList3"
                      :key="index"
                      :class="activeTag4 == index ? 'active-tag' : ''"
                      @click="activeTagHandler4(index)"
                      >{{ item.dic_value }}</a
                    >
                  </div>
                </div>
              </template>
            </div>
            <div class="choice-box" @click="showSearchAllhandler">
              查看全部筛选条件<i
                :class="
                  showSearchAll ? 'el-icon-arrow-up' : 'el-icon-arrow-down'
                "
              ></i>
            </div>
            <div v-if="showBoxStatus" style="margin-top: 27px">
              <ContentLoader
                primaryColor="#f0f2f5"
                secondaryColor="#EFEFEF"
                :base-url="$route.fullPath"
                :animate="false"
                :speed="0"
                height="130"
                width="670"
                viewBox="0 0 670 130"
                v-for="(item, index) in activeCount"
                :key="index"
              >
                <rect x="80" y="20" width="117" height="20" />
                <rect x="80" y="45" width="140" height="23" />
                <rect x="80" y="85" width="250" height="13" />
                <rect x="550" y="20" width="110" height="60" />
                <circle cx="35" cy="50" r="32" />
                <rect x="0" y="129" width="725" height="1" />
              </ContentLoader>
            </div>
            <el-collapse
              v-model="activeNames"
              v-else-if="schoolList.length > 0"
            >
              <div style="font-size: 13px; color: #ff933d">{{ lineDesc }}</div>
              <el-collapse-item
                :name="index + 1 + ''"
                v-for="(item, index) in schoolList"
                :key="index"
                @click.native.once="
                  getSpecialListHandler(index, item.scl_id, item.year)
                "
              >
                <template slot="title">
                  <el-row class="collapse-box">
                    <el-col :span="3">
                      <el-image
                        :src="
                          'https://gaokao.zmpajx.com/pic/' +
                          item.scl_id +
                          '.jpg'
                        "
                        alt="大学logo"
                      >
                        <div slot="error" class="image-slot">
                          <img
                            src="../../assets/images/scl_default.png"
                            alt="大学logo"
                          />
                        </div>
                      </el-image>
                    </el-col>
                    <el-col :span="17">
                      <!-- 学校旁边添加省份 -->
                      <div
                        class="zytb-school-name"
                        @click="schoolDetailHandler(item.scl_id)"
                      >
                        <span>{{ item.scl_name }}</span>
                        <span>{{
                          item.city_name
                        }}</span>
                        <span @click.stop="handleSpeekSchool(item)">解读</span>
                      </div>
                      <div class="zytb-school-tag">
                        <span v-if="item.name">{{ item.name }}</span>
                        <span v-if="item.school_type">{{
                          item.school_type
                        }}</span>
                        <span v-if="item.school_nature">{{
                          item.school_nature
                        }}</span>
                        <span v-if="item.school_nature_type">{{
                          item.school_nature_type
                        }}</span>
                        <span
                          v-if="item.f211 == '1'"
                          style="background: #fff4e3; color: #fe9f0a"
                          >211</span
                        >
                        <span
                          v-if="item.f985 == '1'"
                          style="background: #fff0e9; color: $common-color"
                          >985</span
                        >
                        <span
                          v-if="item.dual_class != '38003' && item.dual_class"
                          style="background: #e4f4e9; color: #01c13b"
                          >双一流</span
                        >
                        <span
                          v-if="item.is_provincial == '1'"
                          style="background: #fdefff; color: #d250e0"
                          >省重点</span
                        >
                        <span
                          v-if="item.is_doublehigh == '77'"
                          style="background: #ecedff; color: #5964ff"
                          >双高计划</span
                        >
                      </div>
                      <div class="zytb-school-count zytb-school-count-diff">
                        <div style="line-height: 20px">
                          <span>{{Number(item.year) + 1}}招生计划{{item.scl_plan_num?item.scl_plan_num:'--'}}人</span>
                          <span>最低学费{{item.min_tuition ? item.min_tuition : '--'}}</span>
                          <span>{{
                            item.college_code
                              ? "院校代码" + item.college_code
                              : ""
                          }}</span>
                        </div>
                        <div style="line-height: 20px;">
                                                    <span>{{item.year}}年最低分{{item.score_min?item.score_min:'--'}}</span>
                                                    <span>最低位次{{item.min_section?item.min_section:'--'}}</span>
                                                    <span v-if="gkInfor.section_line && item.min_section">比我的位次{{gkInfor.section_line - item.min_section >= 0 ? '高' : '低'}}{{Math.abs(gkInfor.section_line - item.min_section)}}</span>
                                                    <span v-else>比我的位次-</span>
                                                </div>
                        <div style="line-height: 20px;margin-bottom: 10px;">
                                                    <span>{{Number(item.year) - 1}}年最低分{{item.sp_min2?item.sp_min2:'--'}}</span>
                                                    <span>最低位次{{item.sp_min_section2?item.sp_min_section2:'--'}}</span>
                                                    <span v-if="gkInfor.section_line && item.sp_min_section2">比我的位次{{gkInfor.section_line - item.sp_min_section2 >= 0 ? '高' : '低'}}{{Math.abs(gkInfor.section_line - item.sp_min_section2)}}</span>
                                                    <span v-else>比我的位次--</span>
                                                </div>
                      </div>
                    </el-col>
                    <el-col :span="4">
                      <div
                        class="zytb-school-fx"
                        :class="
                          item.percent < 20
                            ? 'zytb-school-fx-red'
                            : 'zytb-school-fx-' + selectType
                        "
                      >
                        <div class="zytb-school-tj">
                          <div>推荐度</div>
                          <span>{{ item.percent }}</span
                          ><span class="zytb-school-fx-span">%</span>
                        </div>
                        <div v-if="selectType == '1'" class="zytb-school-ms">
                          <template v-if="item.percent < 20">
                            <div>冲</div>
                            极危风险
                          </template>
                          <template v-else>
                            <div>冲</div>
                            极高风险
                          </template>
                        </div>
                        <div
                          v-else-if="selectType == '2'"
                          class="zytb-school-ms"
                        >
                          <div>稳</div>
                          较低风险
                        </div>
                        <div v-else class="zytb-school-ms">
                          <div>保</div>
                          稍有风险
                        </div>
                      </div>
                      <div class="con-clear"></div>
                      <div class="zytb-school-major">
                        推荐专业({{ item.special_count }})个
                      </div>
                    </el-col>
                  </el-row>
                </template>
                <div v-if="!item.specialList">
                  <ContentLoader
                    primaryColor="#f0f2f5"
                    secondaryColor="#EFEFEF"
                    :base-url="$route.fullPath"
                    height="50"
                    width="670"
                    v-for="item in item.special_count"
                    :key="item"
                  >
                    <rect x="00" y="0" width="60" height="50" />
                    <rect x="85" y="0" width="117" height="20" />
                    <rect x="85" y="30" width="180" height="20" />
                    <rect x="580" y="13" width="90" height="30" />
                  </ContentLoader>
                </div>
                <div v-else>
                  <template v-for="(item1, index1) in item.specialList">
                    <el-row class="plan-box"
                      >{{ item1.plan_group
                      }}<span style="margin: 0">{{
                        item1.first_choose
                      }}</span></el-row
                    >
                    <el-row
                      v-if="item1.pass.length != 0"
                      class="spe_title_pass"
                    >
                      <img
                        src="../../assets/images/special3.png"
                        style="
                          width: 16px;
                          height: 16px;
                          position: relative;
                          top: 2px;
                          margin-right: 3px;
                        "
                      />
                      <span>推荐专业({{ item1.pass.length }})个</span>
                    </el-row>
                    <el-row
                      class="collapse-box collapse-box-diff"
                      v-for="(item2, index2) in item1.pass"
                      :key="item2.special_id"
                    >
                      <el-col :span="20">
                        <el-row class="zytb-school-name">
                          <el-col :span="4" v-if="item1.percent"
                            ><span
                              >{{ item2.percent }}%
                              <div>专业概率</div></span
                            ></el-col
                          >
                          <el-col :span="20">
                            <div
                              style="cursor: pointer"
                              @click="clickHandler(item2)"
                            >
                              <div>
                                {{ item2.spname }}
                                <span
                                  @click.stop="handleSpeekSpecial(item, item2)"
                                  >解读</span
                                >
                              </div>
                              <div class="zytb-school-count">
                                <!-- style="line-height: 20px" -->
                                <div>
                                  <span
                                    >{{ Number(item2.year) + 1 }}招生计划{{
                                      item2.plan_num ? item2.plan_num : "--"
                                    }}人</span
                                  >
                                  <span
                                    >学费{{
                                      item2.tuition ? item2.tuition : "--"
                                    }}</span
                                  >
                                  <span>{{
                                    item2.plan_code
                                      ? "专业代码" + item2.plan_code
                                      : ""
                                  }}</span>
                                </div>
                                <!-- style="line-height: 30px" -->
                                <div>
                                  <span
                                    >{{ item2.year }}招生计划{{
                                      item2.sp_num ? item2.sp_num : "--"
                                    }}人</span
                                  >
                                  <span
                                    >{{ item2.year }}年最低分{{
                                      item2.sp_min ? item2.sp_min : "--"
                                    }}</span
                                  >
                                  <span
                                    >最低位次{{
                                      item2.sp_min_section
                                        ? item2.sp_min_section
                                        : "--"
                                    }}</span
                                  >
                                  <span
                                    v-if="
                                      gkInfor.section_line &&
                                      item2.sp_min_section
                                    "
                                    >比我的位次{{
                                      gkInfor.section_line -
                                        item2.sp_min_section >=
                                      0
                                        ? "高"
                                        : "低"
                                    }}{{
                                      Math.abs(
                                        gkInfor.section_line -
                                          item2.sp_min_section
                                      )
                                    }}</span
                                  >
                                  <span v-else>比我的位次--</span>
                                </div>
                                <div>
                                  <span
                                    >{{ Number(item2.year) - 1 }}招生计划{{
                                      item2.sp_num2 ? item2.sp_num2 : "--"
                                    }}人</span
                                  >
                                  <span
                                    >{{ Number(item2.year) - 1 }}年最低分{{
                                      item2.sp_min2 ? item2.sp_min2 : "-"
                                    }}</span
                                  >
                                  <span
                                    >最低位次{{
                                      item2.sp_min_section2
                                        ? item2.sp_min_section2
                                        : "-"
                                    }}</span
                                  >
                                  <span
                                    v-if="
                                      gkInfor.section_line &&
                                      item2.sp_min_section2
                                    "
                                    >比我的位次{{
                                      gkInfor.section_line -
                                        item2.sp_min_section2 >=
                                      0
                                        ? "高"
                                        : "低"
                                    }}{{
                                      Math.abs(
                                        gkInfor.section_line -
                                          item2.sp_min_section2
                                      )
                                    }}</span
                                  >
                                  <span v-else>比我的位次--</span>
                                </div>
                              </div>
                            </div>
                          </el-col>
                        </el-row>
                      </el-col>
                      <el-col :span="4">
                        <button
                          @click="
                            addZhiYuanHandler(
                              item2,
                              index,
                              item2.new_plan_group,
                              item2.id
                            )
                          "
                          v-if="!item2.active"
                        >
                          加入志愿表
                        </button>
                        <button class="zytb-school-btn" v-else>
                          <img src="../../assets/images/ytj.png" />已添加
                        </button>
                      </el-col>
                      <div class="con-clear"></div>
                    </el-row>
                    <el-row
                      v-if="item1.fail.length != 0"
                      class="spe_title_fail"
                    >
                      <img
                        src="../../assets/images/special4.png"
                        style="
                          width: 16px;
                          height: 16px;
                          position: relative;
                          top: 2px;
                          margin-right: 3px;
                        "
                      />
                      <span
                        >该专业组内其他可填报专业({{
                          item1.fail.length
                        }})个</span
                      >
                    </el-row>
                    <el-row
                      class="collapse-box collapse-box-diff"
                      v-for="(item2, index2) in item1.fail"
                      :key="item2.special_id"
                    >
                      <el-col :span="20">
                        <el-row class="zytb-school-name">
                          <el-col :span="4" v-if="item1.percent"
                            ><span
                              >{{ item2.percent }}%
                              <div>专业概率</div></span
                            ></el-col
                          >
                          <el-col :span="20">
                            <div
                              style="cursor: pointer"
                              @click="clickHandler(item2)"
                            >
                              <div>
                                {{ item2.spname }}
                                <span
                                  @click.stop="handleSpeekSpecial(item, item2)"
                                  >解读</span
                                >
                              </div>
                              <div class="zytb-school-count">
                                <div style="line-height: 20px">
                                  <span
                                    >{{
                                      item2.year
                                        ? Number(item2.year) + 1
                                        : "--"
                                    }}招生计划{{
                                      item2.plan_num ? item2.plan_num : "--"
                                    }}人</span
                                  >
                                  <span
                                    >学费{{
                                      item2.tuition ? item2.tuition : "--"
                                    }}</span
                                  >
                                  <span>{{
                                    item2.plan_code
                                      ? "专业代码" + item2.plan_code
                                      : ""
                                  }}</span>
                                </div>
                                <div style="line-height: 30px">
                                  <span
                                    >{{
                                      item2.year ? item2.year : "--"
                                    }}招生计划{{
                                      item2.sp_num ? item2.sp_num : "--"
                                    }}人</span
                                  >
                                  <span
                                    >{{ item2.year }}年最低分{{
                                      item2.sp_min ? item2.sp_min : "--"
                                    }}</span
                                  >
                                  <span
                                    >最低位次{{
                                      item2.sp_min_section
                                        ? item2.sp_min_section
                                        : "--"
                                    }}</span
                                  >
                                  <span
                                    v-if="
                                      gkInfor.section_line &&
                                      item2.sp_min_section
                                    "
                                    >比我的位次{{
                                      gkInfor.section_line -
                                        item2.sp_min_section >=
                                      0
                                        ? "高"
                                        : "低"
                                    }}{{
                                      Math.abs(
                                        gkInfor.section_line -
                                          item2.sp_min_section
                                      )
                                    }}</span
                                  >
                                  <span v-else>比我的位次--</span>
                                </div>
                                <div style="line-height: 20px">
                                  <span
                                    >{{
                                      item2.year
                                        ? Number(item2.year) - 1
                                        : "--"
                                    }}招生计划{{
                                      item2.sp_num2 ? item2.sp_num2 : "--"
                                    }}人</span
                                  >
                                  <span
                                    >{{
                                      item2.year
                                        ? Number(item2.year) - 1
                                        : "--"
                                    }}年最低分{{
                                      item2.sp_min2 ? item2.sp_min2 : "-"
                                    }}</span
                                  >
                                  <span
                                    >最低位次{{
                                      item2.sp_min_section2
                                        ? item2.sp_min_section2
                                        : "-"
                                    }}</span
                                  >
                                  <span
                                    v-if="
                                      gkInfor.section_line &&
                                      item2.sp_min_section2
                                    "
                                    >比我的位次{{
                                      gkInfor.section_line -
                                        item2.sp_min_section2 >=
                                      0
                                        ? "高"
                                        : "低"
                                    }}{{
                                      Math.abs(
                                        gkInfor.section_line -
                                          item2.sp_min_section2
                                      )
                                    }}</span
                                  >
                                  <span v-else>比我的位次--</span>
                                </div>
                              </div>
                            </div>
                          </el-col>
                        </el-row>
                      </el-col>
                      <el-col :span="4">
                        <button
                          @click="
                            addZhiYuanHandler(
                              item2,
                              index,
                              item2.new_plan_group,
                              item2.id
                            )
                          "
                          v-if="!item2.active"
                        >
                          加入志愿表
                        </button>
                        <button class="zytb-school-btn" v-else>
                          <img src="../../assets/images/ytj.png" />已添加
                        </button>
                        <button
                          style="
                            min-width: 100px;
                            position: absolute;
                            right: 108px;
                          "
                          @click="getSpecialScore(item2.id)"
                          v-if="!item2.sp_min"
                        >
                          往年相似专业
                        </button>
                      </el-col>
                      <div class="con-clear"></div>
                    </el-row>
                  </template>
                </div>
              </el-collapse-item>
              <el-collapse-item
                v-if="
                  !isVip &&
                  cardList[Number(selectType) - 1].count > 3 &&
                  schoolList.length >= 3
                "
                class="el-item-diff"
              >
                <template slot="title">
                  <el-row class="collapse-box">
                    <el-col :span="3">
                      <img
                        src="https://gaokao.zmpajx.com/pic/140.jpg"
                        alt="大学logo"
                      />
                    </el-col>
                    <el-col :span="17">
                      <div class="zytb-school-name">1</div>
                      <div class="zytb-school-tag">
                        <span>1</span>
                        <span>1</span>
                        <span>1</span>
                      </div>
                      <div class="zytb-school-count">
                        <span>2020计划1人</span>
                        <span>2019年最低分1</span>
                        <span>2019年最低位次1</span>
                      </div>
                    </el-col>
                    <el-col :span="4">
                      <div
                        class="zytb-school-fx"
                        :class="'zytb-school-fx-' + selectType"
                      >
                        <div>
                          <span>1</span
                          ><span class="zytb-school-fx-span">%</span>
                        </div>
                        <div v-if="selectType == '1'" class="zytb-school-ms">
                          <div>冲</div>
                          极危风险
                        </div>
                        <div
                          v-else-if="selectType == '2'"
                          class="zytb-school-ms"
                        >
                          <div>稳</div>
                          较低风险
                        </div>
                        <div v-else class="zytb-school-ms">
                          <div>保</div>
                          稍有风险
                        </div>
                      </div>
                      <div class="con-clear"></div>
                      <div class="zytb-school-major">可选专业(1)个</div>
                    </el-col>
                  </el-row>
                </template>
              </el-collapse-item>
            </el-collapse>
            <el-pagination
              background
              layout="prev, pager, next, jumper"
              :total="totalData"
              :page-size="10"
              @current-change="getSchoolListHandler"
              :current-page.sync="currentPage"
              v-if="totalData > 0 && isVip && !showBoxStatus"
            >
            </el-pagination>
            <div v-if="!showBoxStatus">
              <div
                v-if="
                  cardList[Number(selectType) - 1].count == 0 || showDataStatus
                "
                class="no-data-box"
                :class="showSearchAll ? 'no-data-box-diff' : ''"
              >
                <img src="../../assets/images/null.png" alt="没有数据" />
                <p>没有匹配到合适的学校</p>
              </div>
            </div>
            <el-row
              class="zy-active"
              v-if="
                !isVip &&
                cardList[Number(selectType) - 1].count > 3 &&
                schoolList.length >= 3 &&
                !showBoxStatus
              "
            >
              <p>
                激活会员查看<span>所有高薪专业数据</span>智能填报志愿等VIP功能等你使用
              </p>
              <el-button @click="activeVipHandler">激活会员</el-button>
            </el-row>
          </div>
          <div class="zy-text" v-if="gkInfor.score">
            <div
              @mouseenter="linkShowState('true')"
              @mouseleave="linkShowState('false')"
              :style="{ 'text-align': 'right' }"
            >
              {{ gkInfor.subject }} <span></span> {{ gkInfor.score }}
              <span></span>
              <a
                >{{ selectPatch.batch }}
                <i
                  class="el-icon-arrow-down el-icon--right"
                  v-if="linkShow == 'false'"
                ></i
                ><i
                  class="el-icon-arrow-up el-icon--right"
                  v-if="linkShow == 'true'"
                ></i
              ></a>
              <div class="con-score-section" v-if="gkInfor.section_line > 0">
                结合往年数据分析全省排名：{{ gkInfor.section_line }}
              </div>
              <div class="con-score-section" v-else>
                结合往年数据分析全省排名：--
              </div>
              <el-menu v-show="linkShow == 'true'">
                <div v-for="(item, index) in batchList" :key="index">
                  <!-- <li v-if="gkInfor.score < item.grade &&(Object.keys(imitate_form).length == 0 || Object.keys(imitate_form).length != 0 && index != 0 && index != 3)">
                                        <div class="major-patch">{{item.name}}({{item.year}}批次线：{{item.grade}})</div>
                                        <div class="major-patch-bkx">不可选</div>
                                    </li>
                                    <li v-if="gkInfor.score >= item.grade && ( Object.keys(imitate_form).length == 0 || Object.keys(imitate_form).length != 0 && index != 0 && index != 3)" @click="batchActiveHandler(index)">
                                        <div>{{item.name}}({{item.year}}批次线：{{item.grade}})</div>
                                        <img src="../../assets/images/xz.png" alt="选中" v-if="isBatchActive == index">
                                        <img src="../../assets/images/dxk.png" alt="未选中" v-else>
                                    </li> -->
                  <li v-if="gkInfor.score < item.grade">
                    <div class="major-patch">
                      {{ item.name }}({{ item.year }}批次线：{{ item.grade }})
                    </div>
                    <div class="major-patch-bkx">不可选</div>
                  </li>
                  <li
                    v-if="gkInfor.score >= item.grade"
                    @click="batchActiveHandler(index)"
                  >
                    <div>
                      {{ item.name }}({{ item.year }}批次线：{{ item.grade }})
                    </div>
                    <img
                      src="../../assets/images/xz.png"
                      alt="选中"
                      v-if="isBatchActive == index"
                    />
                    <img
                      src="../../assets/images/dxk.png"
                      alt="未选中"
                      v-else
                    />
                  </li>
                </div>
              </el-menu>
            </div>
            <span
              v-if="Object.keys(imitate_form).length == 0"
              class="con-score-span"
              @click="showGkInforHandler"
              ><img src="../../assets/images/edit.png" />
            </span>
          </div>
        </div>
      </el-col>
      <el-col
        :span="7"
        class="zyb-box zyb-box-hh"
        v-if="zybStatus"
        :class="scrollTag ? 'fixed-top' : ''"
        id="fixZyb"
      >
        <el-card>
          <div class="grid-content">
            <el-row class="zyb-title">
              <el-col :span="20">
                <img
                  src="../../assets/images/zyb.png"
                  alt="志愿表"
                  class="zyb-img"
                />
                {{ imitate_form.exam_name }}志愿表
              </el-col>
              <el-col :span="4"
                ><span @click="removePlanHandler">清空</span></el-col
              >
            </el-row>
            <div class="zyb-avg-percent">
              录取总概率：<span>{{ activePlanObj.avg_percent }}%</span>
            </div>
            <GeminiScrollbar class="zyb-bar">
              <el-collapse
                class="zyb-batch"
                v-model="activeZybNames"
                :class="divWidth ? 'zyb-batch-diff' : 'zyb-batch-diff1'"
              >
                <template
                  v-for="(item, key) in batchKeyList"
                  v-if="activePlanObj[item]"
                >
                  <el-collapse-item
                    :key="item.toString()"
                    :name="item.toString()"
                    v-if="activePlanObj[item].count > 0"
                  >
                    <template slot="title">
                      {{ activePlanObj[item].local_batch_type }}({{
                        activePlanObj[item].count
                      }})个
                      <span
                        style="
                          cursor: pointer;
                          display: inline-block;
                          margin-left: 10px;
                        "
                        @click.stop="handleRanks(item)"
                        >排序</span
                      >
                    </template>
                    <vuedraggable
                      v-model="activePlanObj[item].plan_data"
                      element="ul"
                      class="zyb-draggable"
                      animation="300"
                      :data-index="item"
                      @end="draggableSchoolList"
                    >
                      <el-row
                        class="zyb-major"
                        v-for="(item1, index1) in activePlanObj[item].plan_data"
                        :key="index1"
                      >
                        <div v-if="item1.specialty_data.length > 0">
                          <el-col :span="4">
                            <div class="zy-type">
                              {{ item1.plan_type | planType }}
                              <div>志愿</div>
                            </div>
                          </el-col>
                          <el-col :span="20">
                            <el-collapse v-model="activeDetNames">
                              <el-collapse-item
                                class="tzy-collapse-item"
                                :name="
                                  item1.plan_scl.scl_id +
                                  item1.plan_scl.choose_code +
                                  item1.plan_scl.plan_group
                                "
                                :key="
                                  item1.plan_scl.scl_id +
                                  item1.plan_scl.choose_code +
                                  item1.plan_scl.plan_group
                                "
                              >
                                <template slot="title">
                                  <el-col
                                    :span="22"
                                    style="white-space: break-spaces"
                                    >{{ item1.plan_scl.scl_name
                                    }}{{
                                      item1.plan_scl.plan_group
                                        ? item1.plan_scl.plan_group
                                        : ""
                                    }}({{
                                      item1.specialty_data.length
                                    }})</el-col
                                  >
                                  <el-col :span="1">
                                    <img
                                      src="../../assets/images/delete.png"
                                      alt="删除"
                                      title="删除"
                                      @click.stop="
                                        deleteSchoolhandler(item1, index1, item)
                                      "
                                    />
                                  </el-col>
                                  <el-col :span="1">
                                    <img
                                      src="../../assets/images/move.png"
                                      alt="移动"
                                      title="移动"
                                    />
                                  </el-col>
                                </template>
                                <div
                                  v-for="(
                                    item2, index2
                                  ) in item1.specialty_data"
                                  :key="index2"
                                  class="zyb-major-infor"
                                >
                                  <span class="zyb-major-title"
                                    >{{ index2 + 1 }}.{{ item2.spname }} </span
                                  ><span
                                    @click.stop="
                                      deleteMajorhandler(
                                        item,
                                        index1,
                                        index2,
                                        item,
                                        item1,
                                        item2
                                      )
                                    "
                                    class="zyb-major-delete"
                                    >删除</span
                                  >
                                  <div class="zyb-major-percent">
                                    录取概率：<span
                                      >{{
                                        item2.percent ? item2.percent : "-"
                                      }}%</span
                                    >
                                  </div>
                                </div>
                              </el-collapse-item>
                            </el-collapse>
                          </el-col>
                        </div>
                      </el-row>
                    </vuedraggable>
                  </el-collapse-item>
                </template>
              </el-collapse>
            </GeminiScrollbar>
          </div>
        </el-card>
        <div class="add-zyb-btn">
          <el-button @click="savePlanHandler">保存志愿表</el-button>
          <!-- <el-button @click="planSmartHandler">一键填报</el-button> -->
        </div>
      </el-col>
      <el-col
        :span="7"
        class="zyb-box"
        v-else
        :class="scrollTag ? 'fixed-top' : ''"
        id="fixZyb"
      >
        <el-card>
          <div class="grid-content">
            <el-row class="no-data-content">
              <el-col :span="20">
                <img
                  src="../../assets/images/zyb.png"
                  alt="志愿表"
                  class="zyb-img"
                />
                {{ imitate_form.exam_name }}志愿表
              </el-col>
            </el-row>
            <el-row class="no-data-box">
              <img src="../../assets/images/null.png" alt="没有数据" />
              <p>暂无志愿信息</p>
            </el-row>
          </div>
        </el-card>
        <!-- <el-button @click="planSmartHandler">一键填报</el-button> -->
      </el-col>
    </el-row>
    <!-- <el-dialog v-if="showPlanSmart" title="提示" :visible="true" :modal="true" :show-close="false" class="dialog-box dialog-save-plan">
            <img src="../../assets/images/tuoyuan.png" alt="背景图" class="dialog-img">
            <img src="../../assets/images/close.png" alt="关闭" @click="showPlanSmart = false">
            <div slot="footer" class="dialog-footer">
                <p>使用一键填报将会清空表内已填报的志愿，是否继续？</p>
                <div>
                    <el-button @click="showPlanSmart = false" class="vip-btn1">取消</el-button>
                    <el-button @click="planSmartSubmitHandler" class="vip-btn2">保存</el-button>
                </div>
            </div>
        </el-dialog> -->
    <!-- 往年相似专业 -->
    <el-dialog
      title="可参考往年相似专业的录取数据"
      :visible.sync="specialScoreVisible"
      :append-to-body="true"
      :close-on-click-modal="false"
      class="dialog-box"
      width="720px"
    >
      <div
        v-if="special_score.length == 0"
        style="text-align: center; padding: 40px 0"
      >
        <img
          src="../../assets/images/null.png"
          style="width: 100px; height: auto; position: unset"
          alt="没有数据"
        />
        <p style="text-align: center">没有匹配到往年相似专业的录取数据</p>
      </div>
      <el-scrollbar
        v-if="special_score.length != 0"
        wrap-class="vertical_scrollbar"
        style="height: 380px"
      >
        <div
          class="zytb-school-name"
          style="
            margin-bottom: 20px;
            background-color: #fffbf861;
            border: 1px solid #ff9735;
            border-radius: 8px;
            padding: 16px;
          "
          v-for="item in special_score"
          :key="item.special_id"
        >
          <div
            style="
              margin-bottom: 12px;
              font-size: 18px;
              font-weight: 600;
              color: #2c2e33;
            "
          >
            {{ item.spname }}
          </div>
          <div class="zytb-school-count">
            <div style="line-height: 20px; color: #5e6166; font-weight: bold">
              <span style="margin-right: 16px"
                >{{ item.year }}招生计划{{
                  item.sp_num ? item.sp_num : "--"
                }}人</span
              >
              <span style="margin-right: 16px"
                >{{ item.year }}年最低分{{
                  item.sp_min ? item.sp_min : "--"
                }}</span
              >
              <span style="margin-right: 16px"
                >最低位次{{
                  item.sp_min_section ? item.sp_min_section : "--"
                }}</span
              >
              <span v-if="gkInfor.section_line && item.sp_min_section"
                >比我的位次{{
                  gkInfor.section_line - item.sp_min_section >= 0 ? "高" : "低"
                }}{{
                  Math.abs(gkInfor.section_line - item.sp_min_section)
                }}</span
              >
              <span v-else>比我的位次--</span>
            </div>
          </div>
        </div>
      </el-scrollbar>
    </el-dialog>
    <!-- 虚拟的学校解说 -->
    <el-dialog
      :title="SpeekTitle"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
      :visible.sync="SpeekcenterDialogVisible"
      width="80%"
      center
      @close="handleClose"
    >
      <div id="sse_data" style="line-height: 24px"></div>
    </el-dialog>
  </div>
</template>
<script>
import vuedraggable from "vuedraggable";
import { mapState } from "vuex";
import {
  getScoreLine,
  getSearchDic,
  getMajorLevel1,
  getMajorLevel2,
  getSchoolList,
  getSpecialList,
  getSearchSchoolList,
  geSearchSpecialList,
  getSearchJobList,
  getVirtualHistoryData,
  getPlanCount,
  getMyPlanDetail,
  getSpecialListById
} from "@/api/zhiyuan";
import { getHistoryData } from "@/api/home";
import { ContentLoader } from "vue-content-loader";
import marked from "marked";
import {
  getToken,
  getApiSign,
  getBaseURLs,
  nowTime,
  getAesCode,
} from "@/utils/auth.js";
export default {
  components: {
    vuedraggable,
    ContentLoader,
  },
  data() {
    return {
      SpeekcenterDialogVisible: false,
      SpeekTitle: "",
      currentPage: 1,
      aborController: null,
      props: {
        multiple: true,
        value: "cityid",
        label: "name",
        children: "citys",
        emitPath: false,
      },
      // showClose: false,
      isShowSearch: false,
      isShowSearch1: false,
      isShowSearch2: false,
      showDataStatus: false,
      totalData: 0,
      showBoxStatus: true,
      config: {
        width: "200px",
        height: "18px",
        background: "#ddd",
      },
      cardList: [
        { name: "需冲刺", count: "--", type: "1" },
        { name: "较稳妥", count: "--", type: "2" },
        { name: "可保底", count: "--", type: "3" },
      ],
      provinceList: [],
      typeList: [{ dic_value: "全部", flag: true }],
      typeList1: [{ dic_value: "全部" }],
      // typeList2: [
      //     { dic_value: '全部' },
      // ],
      type_edu: {},
      typeList3: [{ dic_value: "全部" }],
      typeList6: [{ dic_value: "全部", flag: true }],
      typeList7: [{ dic_value: "全部" }],
      typeList8: [{ dic_value: "全部" }],
      typeList9: [{ dic_value: "全部", flag: true  }],
      typeList10: [{ dic_value: "全部", flag: true  }],
      activeNames: [],
      activeZybNames: [],
      activeDetNames: [],
      linkShow: "false",
      maList: [],
      // batchList: [{
      //         batch: '本科提前批',
      //         grade: '',
      //         local_batch_type: '6'
      //     },{
      //         batch: '本科一批',
      //         grade: '',
      //         local_batch_type: '7'
      //     },
      //     {
      //         batch: '本科二批',
      //         grade: '',
      //         local_batch_type: '8'
      //     },
      //     {
      //         batch: '专科提前批',
      //         grade: '',
      //         local_batch_type: '11'
      //     },
      //     {
      //         batch: '专科批',
      //         grade: '',
      //         local_batch_type: '10'
      //     }
      // ],
      subject: {
        wl: "物理",
        hx: "化学",
        zz: "政治",
        sw: "生物",
        dl: "地理",
        ls: "历史",
      },
      batchList: JSON.parse(sessionStorage.getItem("batchList")),
      batchObj: JSON.parse(sessionStorage.getItem("batchObj")),
      subjectObj: JSON.parse(sessionStorage.getItem("subjectObj")),
      activeCount: 3,
      isBatchActive: 0,
      showSearchAll: false,
      activeTag: 0,
      activeTag2: 0,
      activeTag3: 0,
      activeTag4: 0,
      activeTag8: 0,
      activeTag9: 0,
      activeTag5: 0,
      activeTag6: 0,
      zybStatus: false,
      gkInfor: {},
      selectPatch: "",
      selectType: "1",
      selectProvince: [],
      selectNature: "",
      selectNatureType: "",
      selectSclType: [],
      schoolList: [],
      lineDesc: "",
      isVip: false,
      schoolListArr: [],
      has_code: 0,
      // savePlanAreaObj: {
      //     '41': {
      //         6: {
      //             local_batch_type: '本科提前批',
      //             local_batch_id: '6',
      //             scl_count: 5,
      //             major_count: 12,
      //             plan_data: []
      //         },
      //         7: {
      //             local_batch_type: '本科一批',
      //             local_batch_id: '7',
      //             scl_count:12,
      //             major_count: 5,
      //             plan_data: []
      //         },
      //         8: {
      //             local_batch_type: '本科二批',
      //             local_batch_id: '8',
      //             scl_count: 12,
      //             major_count: 5,
      //             plan_data: []
      //         },
      //         11: {
      //             local_batch_type: '专科提前批',
      //             local_batch_id: '11',
      //             scl_count: 5,
      //             major_count: 12,
      //             plan_data: []
      //         },
      //         10: {
      //             local_batch_type: '专科批',
      //             local_batch_id: '10',
      //             scl_count: 12,
      //             major_count: 5,
      //             plan_data: []
      //         }
      //     },
      //     '51': {
      //         6: {
      //             local_batch_type: '本科提前批',
      //             local_batch_id: '6',
      //             scl_count: 2,
      //             major_count: 3,
      //             plan_data: []
      //         },
      //         7: {
      //             local_batch_type: '本科一批',
      //             local_batch_id: '7',
      //             scl_count: 9,
      //             major_count: 6,
      //             plan_data: []
      //         },
      //         8: {
      //             local_batch_type: '本科二批',
      //             local_batch_id: '8',
      //             scl_count: 9,
      //             major_count: 6,
      //             plan_data: []
      //         },
      //         11: {
      //             local_batch_type: '专科提前批',
      //             local_batch_id: '11',
      //             scl_count: 3,
      //             major_count: 6,
      //             plan_data: []
      //         },
      //         10: {
      //             local_batch_type: '专科批',
      //             local_batch_id: '10',
      //             scl_count: 9,
      //             major_count: 6,
      //             plan_data: []
      //         }
      //     },
      //     '61': {
      //         6: {
      //             local_batch_type: '本科提前批',
      //             local_batch_id: '6',
      //             scl_count: 3,
      //             major_count: 6,
      //             plan_data: []
      //         },
      //         7: {
      //             local_batch_type: '本科一批',
      //             local_batch_id: '7',
      //             scl_count: 9,
      //             major_count: 6,
      //             plan_data: []
      //         },
      //         8: {
      //             local_batch_type: '本科二批',
      //             local_batch_id: '8',
      //             scl_count: 9,
      //             major_count: 6,
      //             plan_data: []
      //         },
      //         11: {
      //             local_batch_type: '专科提前批',
      //             local_batch_id: '11',
      //             scl_count: 3,
      //             major_count: 6,
      //             plan_data: []
      //         },
      //         10: {
      //             local_batch_type: '专科批',
      //             local_batch_id: '10',
      //             scl_count: 9,
      //             major_count: 6,
      //             plan_data: []
      //         }
      //     },
      //     '13': {
      //         6: {
      //             local_batch_type: '本科提前批',
      //             local_batch_id: '6',
      //             scl_count: 96,
      //             major_count: 1,
      //             plan_data: []
      //         },
      //         10: {
      //             local_batch_type: '专科批',
      //             local_batch_id: '10',
      //             scl_count: 96,
      //             major_count: 1,
      //             plan_data: []
      //         },
      //         14: {
      //             local_batch_type: '本科批',
      //             local_batch_id: '14',
      //             scl_count: 96,
      //             major_count: 1,
      //             plan_data: []
      //         }
      //     }
      // },
      savePlanObj: {},
      savePlanArr: [],
      activeIndex: "",
      activePlanObj: {},
      // batchKeyList: [6, 7, 8, 11, 10],
      planSpeList: [],
      planGroupList: [],
      planSchList: [],
      scrollTag: false,
      divWidth: false,
      searchSchool: {
        gradation: [],
        master_doctor: "",
        doctor: "",
        percent: "",
        select_special_ids: [],
        city_level:[],
        tuition:[]
      },
      optionsSchool: [
        { value: "s1", label: "北京大学" },
        { value: "s3", label: "清华大学" },
        { value: "s17", label: "北京电子科技学院" },
        { value: "s24", label: "北京师范大学" },
        { value: "s2", label: "中国人民大学" },
      ],
      optionsMajor: [
        { value: 299, label: "会计学-本科" },
        { value: 4, label: "经济学-本科" },
        { value: 8, label: "金融学-本科" },
        { value: 1, label: "哲学-本科" },
        { value: 14, label: "法学-本科" },
      ],
      optionsJob: [
        {
          value: "02090500",
          label: "幼儿教师",
        },
        {
          value: "02060300",
          label: "会计人员",
        },
        {
          value: "02050102",
          label: "外科医师",
        },
        {
          value: "02040101",
          label: "飞行驾驶员",
        },
        {
          value: "02080300",
          label: "律师",
        },
      ],
      valueMajor: [],
      valueSchool: [],
      valueJob: [],
      typeMoreList: [
        { type: "1", name: "学校" },
        { type: "2", name: "专业" },
        { type: "3", name: "职业" },
      ],
      hoverMenuStatus: false,
      activeMoreIndex: 0,
      loading: false,
      // showPlanSmart: false,
      imitate_form: {},
      planDetailObj: {},
      special_score: [],
      specialScoreVisible: false,
    };
  },
  computed: {
    ...mapState({
      isZhiYuan: (state) => state.user.isZhiYuan,
      isLogin: (state) => state.user.isLogin,
      token: (state) => state.user.token,
      isVipStr: (state) => state.user.isVipStr,
      requestCount: (state) => state.user.requestCount,
      isShowGk: (state) => state.user.isShowGk,
      provinceCode: (state) => state.user.provinceCode,
      function_code: (state) => state.user.function_code,
    }),
  },
  watch: {
    token(newVal) {
      if (newVal != "") {
        this.$store.commit("user/ADDCOUNT", 0);
        this.getHistoryDataHandler();
      }
    },
    provinceCode(newVal) {
      if (newVal != "" && localStorage.getItem("isProvince") == "true") {
        this.initPlan();
        this.activePlanObj = {};
        this.getHistoryDataHandler();
      }
    },
    requestCount(newVal) {
      if (newVal > 0) {
        this.showBoxStatus = true;
      } else {
        this.showBoxStatus = false;
      }
    },
    isShowGk() {
      if (
        localStorage.getItem("isEdit") == "true" &&
        localStorage.getItem("isProvince") == "false"
      ) {
        this.getPlanCountHandler();
        this.getHistoryDataHandler();
        this.schoolList = [];
        this.majorList = [];
        this.valueMajor = "";
        this.valueSchool = "";
        this.valueJob = "";
        // Object.assign(this.$data.savePlanObj, this.$options.data().savePlanObj)
        this.savePlanArr = [];
        this.activeIndex = "";
        this.activePlanObj = {};
        this.activeZybNames = [];
        this.activeDetNames = [];
        this.planSpeList = [];
        this.planGroupList = [];
        this.planSchList = [];
        this.totalData = 0;
        this.currentPage = 1;
        this.zybStatus = false;
        localStorage.setItem("isEdit", "false");
      }
    },
    isVipStr(newVal) {
      if (newVal == "true") {
        this.$store.commit("user/ADDCOUNT", 0);
        this.activeNames = [];
        this.getSchoolListHandler("1");
        this.activeCount = 10;
      }
    },
    function_code() {
      const tmp = this.function_code.filter((item) => {
        return item.function_code === "F00012";
      });
      if (tmp.length > 0) {
        this.has_code = tmp[0].has_code;
      }
    },
  },
  filters: {
    planType(plan) {
      return plan.split("志愿")[0];
    },
  },
  created() {
    if (this.token == "") {
      this.getSearchDicHandler();
      this.showDataStatus = true;
      this.$store.commit("user/LOGINSTATUS", true);
      return;
    }
    const data = localStorage.getItem("imitate_data");
    if (data) {
      const params = JSON.parse(data);
      this.imitate_form = params;
      this.gkInfor = { ...this.imitate_form };
    }
    this.getPlanCountHandler();
    this.queryuserAgent();
    this.$store.commit("user/ADDCOUNT", 0);
    let type = this.$route.params.type;
    if (type == "1") {
      this.selectType = "3";
    } else if (type == "2") {
      this.selectType = "2";
    } else if (type == "3") {
      this.selectType = "1";
    } else {
      this.selectType = "1";
    }
    this.getSearchDicHandler();
    if (Object.keys(this.imitate_form).length > 0) {
      this.getVirtualHistoryData();
    } else {
      this.getHistoryDataHandler();
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("scroll", this.getScroll, true);
    });
    const tmp = this.function_code.filter((item) => {
      return item.function_code === "F00012";
    });
    if (tmp.length > 0) {
      this.has_code = tmp[0].has_code;
    }
  },
  methods: {
    handleRanks(item) {
  // 安全取出当前批次的志愿列表（兼容Vue2老项目，无可选链语法）
  var planList = (this.activePlanObj[item] && this.activePlanObj[item].plan_data) || [];
  
  // 1. 按志愿内专业平均录取概率升序排序（冲→稳→保，概率低的在前）
  planList.sort((a, b) => {
    // 计算a志愿的平均录取概率
    var avgA = 0;
    if (a.specialty_data && a.specialty_data.length > 0) {
      var totalA = a.specialty_data.reduce(function(sum, spe) {
        var num = Number(spe.percent);
        return sum + (isNaN(num) ? 0 : num);
      }, 0);
      avgA = totalA / a.specialty_data.length;
    } else {
      // 空志愿排到列表末尾
      avgA = Infinity;
    }

    // 计算b志愿的平均录取概率
    var avgB = 0;
    if (b.specialty_data && b.specialty_data.length > 0) {
      var totalB = b.specialty_data.reduce(function(sum, spe) {
        var num = Number(spe.percent);
        return sum + (isNaN(num) ? 0 : num);
      }, 0);
      avgB = totalB / b.specialty_data.length;
    } else {
      avgB = Infinity;
    }

    return avgA - avgB;
  });

  // 2. 核心修复：排序后重置志愿序号，保证始终是 1志愿、2志愿、3志愿... 连续顺序
  planList.forEach(function(item, index) {
    item.plan_type = (index + 1) + '志愿';
  });

  // 3. 强制触发Vue2响应式更新，保证视图同步刷新
  this.$set(this.activePlanObj[item], 'plan_data', planList.slice());
},
    handleClose() {
      if (this.aborController) {
        this.aborController.abort();
        this.aborController = null;
      }
    },
    // 学校解读
    handleSpeekSchool(item) {
      let that = this
      const sseElement = document.getElementById("sse_data");
      if (sseElement) {
        sseElement.innerHTML = "";
      }
      let { area, local_type_id, scl_name } = item;
      this.SpeekTitle = scl_name;
      let score = this.gkInfor.score;
      let param = {
        area: area,
        score: score,
        scl_name: scl_name,
        local_type_id: local_type_id,
      };
      let encrypted_data_obj = JSON.parse(
        localStorage.getItem("encrypted_data")
      );
      encrypted_data_obj.timestamp = nowTime();
      let encrypted_data = getAesCode(encrypted_data_obj);
      param.token = getToken();
      param.client_id = "74450c23fa139888c2240568a276879d";
      param.encrypted_data = encrypted_data;
      param.sign = getApiSign(param);
      let ret = "";
      for (const it in param) {
        ret +=
          encodeURIComponent(it) + "=" + encodeURIComponent(param[it]) + "&";
      }
      ret = ret.substr(0, ret.length - 1);
      var url = getBaseURLs() + "api/ai/explain_school?" + ret;
      let sse_data = "";
      this.SpeekcenterDialogVisible = true;
      fallbackToFetch();
      async function fallbackToFetch() {
        if (that.aborController) {
          that.aborController.abort();
          that.aborController = null;
        }
        let reader = null;
        let sse_data = "";
        try {
          that.aborController = new AbortController();
          const { signal } = that.aborController;
          if (signal.aborted) {
            console.log("请求已被中止，无法发起新请求");
            return;
          }
          const response = await fetch(url, {
            signal: signal,
          });
          if (!response.ok) {
            throw new Error(`HTTP错误: ${response.status}`);
          }
          reader = response.body.getReader();
          while (true) {
            if (signal.aborted) {
              throw new Error("请求已被用户中断");
            }
            const { done, value } = await reader.read();
            console.log(done)
            // that.showClose = done;
            if (done) break;
            const decodedValue = new TextDecoder().decode(value);
            if (decodedValue.indexOf("DONE") === -1) {
              sse_data += decodedValue;
            }

            if (decodedValue.indexOf("message") !== -1) {
              try {
                sse_data = JSON.parse(decodedValue).message;
              } catch (jsonError) {
                console.error("JSON解析失败:", jsonError);
              }
            }
            const sseElement = document.getElementById("sse_data");
            if (sseElement) {
              sseElement.innerHTML = marked(sse_data);
              document.querySelectorAll("hr").forEach((hr) => {
                hr.style.marginTop = "16px";
                hr.style.marginBottom = "16px";
              });
            }
          }
        } catch (error) {
          if (
            error.name === "AbortError" ||
            error.message === "请求已被用户中断"
          ) {
            console.log("用户已中断请求");
          } else if (error.message.startsWith("HTTP错误")) {
            console.error("请求失败:", error.message);
          } else {
            console.error("处理流时发生错误:", error);
          }
        } finally {
          if (reader) {
            try {
              reader.releaseLock();
            } catch (e) {
              console.log("释放流锁时出错:", e);
            }
          }
        }
      }
    },
    // 专业解读
    handleSpeekSpecial(item, item1) {
      let that = this
      const sseElement = document.getElementById("sse_data");
      if (sseElement) {
        sseElement.innerHTML = "";
      }
      let { scl_name } = item;
      let { spname } = item1;
      this.SpeekTitle = scl_name + "-" + spname;
      let param = {
        special_name: spname,
        scl_name: scl_name,
      };
      let encrypted_data_obj = JSON.parse(
        localStorage.getItem("encrypted_data")
      );
      encrypted_data_obj.timestamp = nowTime();
      let encrypted_data = getAesCode(encrypted_data_obj);
      param.token = getToken();
      param.client_id = "74450c23fa139888c2240568a276879d";
      param.encrypted_data = encrypted_data;
      param.sign = getApiSign(param);
      let ret = "";
      for (const it in param) {
        ret +=
          encodeURIComponent(it) + "=" + encodeURIComponent(param[it]) + "&";
      }
      ret = ret.substr(0, ret.length - 1);
      var url = getBaseURLs() + "api/ai/explain_special?" + ret;
      let sse_data = "";
      this.SpeekcenterDialogVisible = true;
      fallbackToFetch();
      async function fallbackToFetch() {
        if (that.aborController) {
          that.aborController.abort();
          that.aborController = null;
        }
        let reader = null;
        let sse_data = "";
        try {
          that.aborController = new AbortController();
          const { signal } = that.aborController;
          if (signal.aborted) {
            console.log("请求已被中止，无法发起新请求");
            return;
          }
          const response = await fetch(url, {
            signal: signal,
          });
          if (!response.ok) {
            throw new Error(`HTTP错误: ${response.status}`);
          }
          reader = response.body.getReader();
          while (true) {
            if (signal.aborted) {
              throw new Error("请求已被用户中断");
            }
            const { done, value } = await reader.read();
            // that.showClose = done;
            if (done) break;
            const decodedValue = new TextDecoder().decode(value);
            if (decodedValue.indexOf("DONE") === -1) {
              sse_data += decodedValue;
            }

            if (decodedValue.indexOf("message") !== -1) {
              try {
                sse_data = JSON.parse(decodedValue).message;
              } catch (jsonError) {
                console.error("JSON解析失败:", jsonError);
              }
            }
            const sseElement = document.getElementById("sse_data");
            if (sseElement) {
              sseElement.innerHTML = marked(sse_data);
              document.querySelectorAll("hr").forEach((hr) => {
                hr.style.marginTop = "16px";
                hr.style.marginBottom = "16px";
              });
            }
          }
        } catch (error) {
          if (
            error.name === "AbortError" ||
            error.message === "请求已被用户中断"
          ) {
            console.log("用户已中断请求");
          } else if (error.message.startsWith("HTTP错误")) {
            console.error("请求失败:", error.message);
          } else {
            console.error("处理流时发生错误:", error);
          }
        } finally {
          if (reader) {
            try {
              reader.releaseLock();
            } catch (e) {
              console.log("释放流锁时出错:", e);
            }
          }
        }
      }
    },
    getPlanCountHandler() {
      getPlanCount().then((res) => {
        this.batchKeyList = Object.keys(this.batchObj);
        res.data.map((item) => {
          item.plan_data = [];
          this.savePlanObj[item.local_batch_id] = item;
        });
        for (const key in this.batchObj) {
          if (Object.hasOwnProperty.call(this.batchObj, key)) {
            const element = this.batchObj[key];
            for (let i = 1; i <= this.savePlanObj[key].scl_count; i++) {
              let title_tmp = i;
              const obj = {
                plan_type: `${title_tmp}志愿`,
                plan_scl: {},
                specialty_data: [],
              };
              this.savePlanObj[key].plan_data.push(obj);
            }
          }
        }
        localStorage.setItem("savePlanArr1", JSON.stringify(this.savePlanObj));
        if (this.$route.query.id) {
          this.getMyPlanDetailHandler(this.$route.query.id);
        }
        if (localStorage.getItem("savePlanData")) {
          var savePlanData = JSON.parse(localStorage.getItem("savePlanData"));
          this.planSpeList = savePlanData.planSpeList;
          this.planGroupList = savePlanData.planGroupList;
          this.activePlanObj = savePlanData.activePlanObj;
          this.savePlanObj = savePlanData.savePlanObj;
          this.activeDetNames = savePlanData.activeDetNames;
          this.activeZybNames = savePlanData.activeZybNames;
          this.zybStatus = savePlanData.zybStatus;
        }
        // console.log(JSON.parse(localStorage.getItem("savePlanData")));
      });
    },
    saveLocalStoragePlanHandler() {
      if (!this.zybStatus) {
        localStorage.removeItem("savePlanData");
      }
      if (this.zybStatus) {
        var savePlanData = {
          planSpeList: this.planSpeList,
          planGroupList: this.planGroupList,
          activePlanObj: this.activePlanObj,
          savePlanObj: this.savePlanObj,
          activeDetNames: this.activeDetNames,
          activeZybNames: this.activeZybNames,
          zybStatus: this.zybStatus,
        };
        localStorage.setItem("savePlanData", JSON.stringify(savePlanData));
      }
    },
    getScroll() {
      let div = document.getElementById("app");
      let top = div.scrollTop;
      if (top > 300) {
        this.scrollTag = true;
      } else {
        this.scrollTag = false;
      }
    },
    queryuserAgent() {
      var userAgent = navigator.userAgent;
      if (
        (userAgent.indexOf("Safari") > -1 ||
          userAgent.indexOf("iPhone") > -1) &&
        userAgent.indexOf("Chrome") == -1
      ) {
        this.divWidth = true;
      }
    },
    showGkInforHandler() {
      this.$store.commit("user/SHOWGKINFOR", true);
    },
    getHistoryDataHandler() {
      getHistoryData(localStorage.getItem("area")).then((res) => {
        if (res.status == "200") {
          if (!res.data) {
            this.showDataStatus = true;
          } else {
            const data = res.data;
            const subject = this.subjectObj[data.local_type_id].name;
            const batch = this.batchObj[data.local_batch_type].name;
            this.showAddZhiStatus = false;
            this.gkInfor = data;
            this.gkInfor = Object.assign({}, this.gkInfor, {
              subject: subject,
              batch: batch,
              section_line: data.section,
              count1: data.count3,
              count3: data.count1,
            });
            this.$store.commit("user/EDITGKINFOR", this.gkInfor);
            // localStorage.setItem("savePlanArr1", JSON.stringify(this.savePlanObj));
            this.selectPatch = this.gkInfor;
            this.getMajorsHandler1();
            this.getScoreLineHandler();
            this.activeNames = [];
            this.getSchoolListHandler("1");
          }
        } else {
          this.$message({
            message: "暂无数据，请重新填写信息",
            type: "error",
          });
          // this.$store.commit('user/EDITGKINFOR', {});
          this.$store.commit("user/SHOWGKINFOR", true);
          this.showDataStatus = true;
          this.showBoxStatus = false;
        }
      });
    },
    getVirtualHistoryData() {
      getVirtualHistoryData(this.imitate_form).then((res) => {
        if (res.status == 200) {
          const data = res.data;
          const subject = this.subjectObj[data.local_type_id].name;
          const batch = this.batchObj[data.local_batch_type].name;
          this.showAddZhiStatus = false;
          this.gkInfor = data;
          this.gkInfor = Object.assign({}, this.gkInfor, {
            subject: subject,
            batch: batch,
            section_line: data.section,
            count1: data.count3,
            count3: data.count1,
          });
          this.$store.commit("user/EDITGKINFOR", this.gkInfor);
          localStorage.setItem(
            "savePlanArr1",
            JSON.stringify(this.savePlanObj)
          );
          this.selectPatch = this.gkInfor;
          this.getMajorsHandler1();
          this.getScoreLineHandler();
          this.activeNames = [];
          this.getSchoolListHandler("1");
          if (this.imitate_form.flag == "edit") {
            this.updateZhiyuanHandler();
          }
        } else {
          this.$message({
            message: res.message,
            type: "error",
          });
        }
      });
    },
    handleChangeCard(e) {
      let type = parseInt(e.index) + 1;
      this.selectType = type.toString();
      this.schoolList = [];
      (this.currentPage = 1), (this.totalData = 0), (this.activeNames = []);
      if (this.cardList[e.index].count > 0) {
        this.activeNames = [];
        this.getSchoolListHandler("1");
      }
    },
    linkShowState(linkShow) {
      this.linkShow = linkShow;
    },
    batchActiveHandler(index) {
      this.isBatchActive = index;
      const select_tmp = {
        batch: this.batchList[index].name,
        local_batch_type: this.batchList[index].local_batch_id,
      };
      this.selectPatch = select_tmp;
      this.getMajorsHandler1();
      this.resetGetSchoolListHandler();
    },
    showSearchAllhandler() {
      this.showSearchAll = !this.showSearchAll;
    },
    activeTagHandler(data) {
      // if(index == 0) {
      //     this.provinceList.map(item => {
      //         item.flag = false
      //     })
      //     this.provinceList[0].flag = true
      //     this.selectProvince = []
      // } else {
      //     this.provinceList[0].flag = false
      //     this.provinceList[index].flag = !this.provinceList[index].flag
      //     if(item.flag) {
      //         this.selectProvince.push(this.provinceList[index].provinceid)
      //     } else {
      //         const tmp = this.selectProvince.findIndex(val => {return val === item.provinceid})
      //         this.selectProvince.splice(tmp, 1)
      //     }
      // }
      this.selectProvince = data;
      this.resetGetSchoolListHandler();
    },
    activeMaHandler(data) {
      this.searchSchool.select_special_ids = data;
      this.resetGetSchoolListHandler();
    },
    activeTagHandler1(item, index) {
      if (index == 0) {
        this.typeList.map((item) => {
          item.flag = false;
        });
        this.typeList[0].flag = true;
        this.selectSclType = [];
      } else {
        this.typeList[0].flag = false;
        this.typeList[index].flag = !this.typeList[index].flag;
        if (item.flag) {
          this.selectSclType.push(this.typeList[index].dic_code);
        } else {
          const tmp = this.selectSclType.findIndex((val) => {
            return val === item.dic_code;
          });
          this.selectSclType.splice(tmp, 1);
        }
      }
      this.resetGetSchoolListHandler();
    },
    activeTagHandler2(index) {
      this.activeTag2 = index;
      this.selectNature = this.typeList1[index].dic_code;
      this.resetGetSchoolListHandler();
    },

    // activeTagHandler3(index) {
    //     this.activeTag3 = index;
    //     this.selectNatureType = this.typeList2[index].dic_code;
    //     this.resetGetSchoolListHandler();
    // },
    activeTagHandler4(index) {
      this.activeTag4 = index;
      this.searchSchool.percent = this.typeList3[index].dic_code;
      this.resetGetSchoolListHandler();
    },
    activeTagHandler7(item, index) {
      if (index == 0) {
        this.typeList6.map((item) => {
          item.flag = false;
        });
        this.typeList6[0].flag = true;
        this.searchSchool.gradation = [];
      } else {
        this.typeList6[0].flag = false;
        this.typeList6[index].flag = !this.typeList6[index].flag;
        if (item.flag) {
          this.searchSchool.gradation.push(this.typeList6[index].dic_code);
        } else {
          const tmp = this.searchSchool.gradation.findIndex((val) => {
            return val === item.dic_code;
          });
          this.searchSchool.gradation.splice(tmp, 1);
        }
      }
      this.resetGetSchoolListHandler();
    },
    activeTagHandler8(index) {
      this.activeTag8 = index;
      this.searchSchool.master_doctor = this.typeList7[index].dic_code;
      this.resetGetSchoolListHandler();
    },
    activeTagHandler9(index) {
      this.activeTag9 = index;
      this.searchSchool.doctor = this.typeList8[index].dic_code;
      this.resetGetSchoolListHandler();
    },
    activeTagHandler5(item,index){
      if(index === 0){
        this.typeList10.map((item) => {
          item.flag = false;
        });
        this.typeList10[0].flag = true;
        this.searchSchool.city_level = [];
      }else{
        this.typeList10[0].flag = false;
        this.typeList10[index].flag = !this.typeList10[index].flag;
        if (item.flag) {
          this.searchSchool.city_level.push(this.typeList10[index].dic_code);
        } else {
          const tmp = this.searchSchool.city_level.findIndex((val) => {
            return val === item.dic_code;
          });
          this.searchSchool.city_level.splice(tmp, 1);
          if(this.searchSchool.city_level.length === 0){
            this.typeList10[0].flag = true;
            this.searchSchool.city_level = [];
          }
        }
      }
      
      // this.activeTag5 = index;
      // this.searchSchool.city_level = this.typeList9[index].dic_code;
      this.resetGetSchoolListHandler();
    },
    activeTagHandler6(item,index){
      if(index === 0){
        this.typeList9.map((item) => {
          item.flag = false;
        });
        this.typeList9[0].flag = true;
        this.searchSchool.tuition = [];
      }else{
        this.typeList9[0].flag = false;
        this.typeList9[index].flag = !this.typeList9[index].flag;
        if (item.flag) {
          this.searchSchool.tuition.push(this.typeList9[index].dic_code);
        } else {
          const tmp = this.searchSchool.tuition.findIndex((val) => {
            return val === item.dic_code;
          });
          this.searchSchool.tuition.splice(tmp, 1);
          if(this.searchSchool.tuition.length === 0){
            this.typeList9[0].flag = true;
            this.searchSchool.tuition = [];
          }
        }
      }
      // this.activeTag6 = index;
      // this.searchSchool.tuition = this.typeList10[index].dic_code;
      this.resetGetSchoolListHandler();
    },
    resetGetSchoolListHandler() {
      this.schoolList = [];
      (this.currentPage = 1), (this.totalData = 0), (this.activeNames = []);
      this.getSchoolListHandler("1");
    },
    addZhiYuanHandler(major, index, index1, id) {
      this.zybStatus = true;
      let savePlan = Object.assign(
        {},
        this.savePlanObj[this.selectPatch.local_batch_type]
      );
      let schoolInfor = this.schoolList[index];
      let majorList = schoolInfor.planList[index1];
      let planSpeList = Object.assign([], this.planSpeList);
      let planGroupList = Object.assign([], this.planGroupList);
      // let planSclList = Object.assign([], this.planSclList);
      if (
        planGroupList.indexOf(
          this.schoolList[index].scl_id + major.choose_code + major.plan_group
        ) == -1
      ) {
        let planArr = savePlan.plan_data.filter(
          (item) =>
            item.plan_scl.scl_id +
            item.plan_scl.choose_code +
            item.plan_scl.plan_group
        );
        let flag = false;
        if (planArr.length == savePlan.scl_count) {
          this.$message({
            message: "该批次志愿已满",
            type: "warning",
          });
          return;
        }
      }
      let plan_scl = Object.assign({}, this.schoolListArr[index]);
      plan_scl.plan_group = major.plan_group;
      plan_scl.choose_code = major.choose_code;
      plan_scl.second_choose = major.second_choose;
      plan_scl.first_choose = major.first_choose;
      let plan_spe = major;
      this.activeDetNames = [];
      this.activeZybNames = [];
      let flag1 = "1";
      savePlan.plan_data.some((e, index) => {
        if (Object.keys(e.plan_scl).length == 0) {
          if (e.specialty_data.length > savePlan.spec_count - 1) {
            flag1 = "2";
            return true;
          }
          e.plan_scl = plan_scl;
          e.specialty_data.push(plan_spe);
          planSpeList.push(plan_spe.id);
          // planSclList.push(plan_scl.scl_id);
          planGroupList.push(
            plan_scl.scl_id + plan_scl.choose_code + plan_scl.plan_group
          );
          return true;
        } else {
          if (
            e.plan_scl.scl_id +
              e.plan_scl.choose_code +
              e.plan_scl.plan_group ==
            plan_scl.scl_id + plan_scl.choose_code + plan_scl.plan_group
          ) {
            if (e.specialty_data.length > savePlan.spec_count - 1) {
              flag1 = "2";
              return true;
            }
            e.specialty_data.push(plan_spe);
            planSpeList.push(plan_spe.id);
            return true;
          }
        }
      });
      if (flag1 == "2") {
        this.$message({
          message: "该志愿专业数量已达上限",
          type: "warning",
        });
      } else {
        // majorList[index2].active = true;
        majorList.forEach((item) => {
          if (item.id == id) {
            item.active = true;
          }
        });
        schoolInfor.majorList = majorList;
        this.$set(this.schoolList, index, schoolInfor);
      }
      this.planSpeList = Object.assign([], planSpeList);
      this.planGroupList = Object.assign([], planGroupList);
      // this.planSclList = Object.assign([], planSclList);
      const count = savePlan.plan_data.filter((item) => {
        return Object.keys(item.plan_scl).length != 0;
      });
      savePlan.count = count.length;
      this.sortScl(this.schoolList[index].scl_id, savePlan);
      this.$set(this.savePlanObj, this.selectPatch.local_batch_type, savePlan);
      this.savePlanArr = Object.assign([], savePlan.plan_data);
      for (const el in this.savePlanObj) {
        if (this.savePlanObj[el].count > 0) {
          this.activePlanObj[el] = this.savePlanObj[el];
        }
      }
      // for (let index = 0; index < count; index++) {
      //     this.activeZybNames.push(index.toString())
      // }
      let total_percent = 0;
      let count_tmp = 0;
      for (const key in this.activePlanObj) {
        if (Object.hasOwnProperty.call(this.activePlanObj, key)) {
          let value = this.activePlanObj[key].plan_data;
          for (const key1 in value) {
            if (Object.hasOwnProperty.call(value, key1)) {
              if (value[key1].specialty_data.length > 0) {
                value[key1].specialty_data.map((item) => {
                  if (item.percent) {
                    total_percent += item.percent * 1;
                  }
                  count_tmp++;
                });
                this.activeDetNames.push(
                  value[key1].plan_scl.scl_id +
                    value[key1].plan_scl.choose_code +
                    value[key1].plan_scl.plan_group
                );
              }
            }
          }

          this.activeZybNames.push(key.toString());
        }
      }
      console.log(total_percent, count_tmp);
      this.activePlanObj.avg_percent = (total_percent / count_tmp).toFixed(0);
      this.saveLocalStoragePlanHandler();
    },
    sortScl(scl_id, savePlan) {
      savePlan.plan_data.map((item, index) => {
        if (index + 1 < savePlan.plan_data.length) {
          if (Object.keys(savePlan.plan_data[index + 1].plan_scl).length > 0) {
            const arr = savePlan.plan_data.slice(index + 1);
            const tmpIndex = arr.findIndex((val) => {
              return item.plan_scl.scl_id === val.plan_scl.scl_id;
            });
            if (tmpIndex != -1) {
              const plan1 = { ...savePlan.plan_data[index + 1] };
              const planTmp = { ...arr[tmpIndex] };
              savePlan.plan_data[index + 1].plan_scl = planTmp.plan_scl;
              savePlan.plan_data[index + 1].specialty_data =
                planTmp.specialty_data;
              savePlan.plan_data[index + 1 + tmpIndex].plan_scl =
                plan1.plan_scl;
              savePlan.plan_data[index + 1 + tmpIndex].specialty_data =
                plan1.specialty_data;
            }
          }
        }
      });
      return savePlan;
    },
    getScoreLineHandler() {
      const local_type_id = this.gkInfor.local_type_id;
      getScoreLine(local_type_id, localStorage.getItem("area"))
        .then((res) => {
          if (res.status != 200 || !res) {
            return;
          }
          const data = res.data.pro_score;
          this.batchList.forEach((item, index) => {
            this.$set(
              this.batchList[index],
              "grade",
              data[item.local_batch_id]
            );
            this.$set(this.batchList[index], "year", res.data.pro_year);
            if (item.local_batch_id == this.gkInfor.local_batch_type) {
              this.isBatchActive = index;
            }
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getSearchDicHandler() {
      try {
        getSearchDic()
          .then((res) => {
            if (res.status != 200 || !res) {
              return;
            }
            // console.log(res,'res')
            res.data.city_level.map((item) => {
              item.flag = false;
              return item;
            });
            res.data.tuition.map((item) => {
              item.flag = false;
              return item;
            });
            res.data.province.map((item) => {
              item.flag = false;
              item.cityid = item.provinceid;
              return item;
            });
            res.data.gradation.map((item) => {
              item.flag = false;
              return item;
            });
            res.data.edu_type.map((item) => {
              this.type_edu[item.dic_code] = item.dic_value;
            });
            this.provinceList.push(...res.data.province);
            this.typeList.push(...res.data.scl_type);
            this.typeList1.push(...res.data.scl_nature);
            // this.typeList2.push(...res.data.edu_type);
            this.typeList3.push(...res.data.percent);
            this.typeList6.push(...res.data.gradation);
            this.typeList7.push(...res.data.master_doctor);
            this.typeList8.push(...res.data.doctor);
            this.typeList9.push(...res.data.tuition);
            this.typeList10.push(...res.data.city_level);
          })
          .catch((error) => {
            console.log(error);
          });
      } catch (error) {
        console.log(error);
      }
    },
    getMajorsHandler1() {
      getMajorLevel1(this.selectPatch.local_batch_type).then((res) => {
        if (res.status != 200 || !res) {
          return;
        }
        this.maList = res.data;
      });
    },
    getMajorsHandler2(node, resolve) {
      if (!node.value || !node.hasChildren) {
        resolve([]);
        return;
      }
      getMajorLevel2(node.value).then((res) => {
        const nodes = res.data.map((item) => {
          item.leaf = true;
          return item;
        });
        resolve(nodes);
      });
    },
    getSchoolListHandler(page) {
      this.activeNames = [];
      this.schoolList = [];
      const type = this.selectType;
      const params = {
        score: this.gkInfor.score,
        local_type_id: this.gkInfor.local_type_id,
        section_line: this.gkInfor.section_line,
        local_batch_type: this.selectPatch.local_batch_type,
        type: this.selectType,
        city: this.selectProvince.join(","),
        scl_type: this.selectSclType.join(","),
        scl_nature: this.selectNature,
        scl_nature_type: this.selectNatureType,
        scl_ids: this.valueSchool,
        special_ids: this.valueMajor,
        job_codes: this.valueJob,
        gradation: this.searchSchool.gradation.join(","),
        master_doctor: this.searchSchool.master_doctor,
        doctor: this.searchSchool.doctor,
        percent: this.searchSchool.percent,
        tuition: this.searchSchool.tuition.join(","),
        city_level: this.searchSchool.city_level.join(","),
        select_special_ids: this.searchSchool.select_special_ids.join(","),
        page: page,
      };
      // console.log(params,'params')
      try {
        getSchoolList(params)
          .then(async (res) => {
            if (res.status != 200) {
              this.cardList = [
                { name: "需冲刺", count: "--", type: "1" },
                { name: "较稳妥", count: "--", type: "2" },
                { name: "可保底", count: "--", type: "3" },
              ];
              this.showDataStatus = true;
              this.showBoxStatus = false;
              return;
            }
            this.showDataStatus = false;
            this.showBoxStatus = false;
            this.$set(this.cardList[0], "count", res.data.count1);
            this.$set(this.cardList[1], "count", res.data.count2);
            this.$set(this.cardList[2], "count", res.data.count3);
            if (res.data.count1 <= 3) {
              this.$set(this.cardList[0], "activeCount", res.data.count1);
            } else {
              this.$set(this.cardList[0], "activeCount", 3);
            }
            if (res.data.count2 <= 3) {
              this.$set(this.cardList[1], "activeCount", res.data.count2);
            } else {
              this.$set(this.cardList[1], "activeCount", 3);
            }
            if (res.data.count3 <= 3) {
              this.$set(this.cardList[2], "activeCount", res.data.count3);
            } else {
              this.$set(this.cardList[2], "activeCount", 3);
            }
            if (!res.data || res.data.data.length == 0) {
            } else {
              const data = res.data.data;
              const schoolList = [];
              const schoolListArr = [];
              data.forEach((item, index) => {
                let obj = {};
                let school_type = "";
                let school_nature = "";
                obj = Object.assign({}, item);
                if (item.scl_type == "5000") {
                  school_type = "综合";
                } else if (item.scl_type == "5001") {
                  school_type = "理工";
                } else if (item.scl_type == "5002") {
                  school_type = "农林";
                } else if (item.scl_type == "5003") {
                  school_type = "医药";
                } else if (item.scl_type == "5004") {
                  school_type = "师范";
                } else if (item.scl_type == "5005") {
                  school_type = "语言";
                } else if (item.scl_type == "5006") {
                  school_type = "财经";
                } else if (item.scl_type == "5007") {
                  school_type = "政法";
                } else if (item.scl_type == "5008") {
                  school_type = "体育";
                } else if (item.scl_type == "5009") {
                  school_type = "艺术";
                } else if (item.scl_type == "5010") {
                  school_type = "民族";
                } else if (item.scl_type == "5011") {
                  school_type = "军事";
                } else {
                  school_type = "其他";
                }
                if (item.scl_nature == "36000") {
                  school_nature = "公办";
                } else if (item.scl_nature == "36001") {
                  school_nature = "民办";
                } else if (item.scl_nature == "36002") {
                  school_nature = "中外合作办学";
                }
                // if (item.scl_nature_type == '6000') {
                //     if(item.f211 == '1' || item.f985 == '1' || item.is_provincial == '1' || (item.dual_class != '38003' && item.dual_class)) {
                //         school_nature_type = '本科'
                //     } else {
                //         school_nature_type = '普通本科'
                //     }
                // } else if (item.scl_nature_type == '6001') {
                //     if(item.is_doublehigh == '77') {
                //         school_nature_type = '专科'
                //     } else {
                //         school_nature_type = '普通专科'
                //     }
                // } else if (item.scl_nature_type == '6002') {
                //     school_nature_type = '中外合作办学'
                // }
                obj.school_type = school_type;
                obj.school_nature = school_nature;
                obj.school_nature_type = this.type_edu[item.scl_nature_type];
                schoolList.push(obj);
                schoolListArr.push(item);
              });
              this.schoolListArr = schoolListArr;
              this.schoolList = schoolList;
              this.isVip = res.data.is_vip;
              this.totalData = res.data["count" + type];
            }
            this.lineDesc = res.data.tip;
          })
          .catch((error) => {
            console.log(error);
          });
      } catch (error) {
        console.log(error);
      }
    },
    getSpecialListHandler(index, scl_id, year) {
      const params = {
        scl_id: scl_id,
        year: year,
        score: this.gkInfor.score,
        local_type_id: this.gkInfor.local_type_id,
        local_batch_type: this.selectPatch.local_batch_type,
        type: this.selectType,
        area: localStorage.getItem("area"),
        city: localStorage.getItem("area"),
        special_ids: this.valueMajor,
        job_codes: this.valueJob,
        select_special_ids: this.searchSchool.select_special_ids.join(","),
        percent: this.searchSchool.percent,
      };
      getSpecialList(params).then((res1) => {
        let specialList = res1.data.data;
        let planSpeList = Object.assign([], this.planSpeList);
        let planGroupList = Object.assign([], this.planGroupList);
        const schoolNewList = this.schoolList;
        const majorList = [];
        const planNewList = {};
        specialList.map((item1) => {
          // var new_special = item1.pass.concat(item1.fail);
          var choose_code = "";
          item1.pass.map((item2) => {
            if (
              planSpeList.indexOf(item2.id) != -1 &&
              planGroupList.indexOf(
                scl_id + item2.choose_code + item2.plan_group
              ) != -1
            ) {
              item2.active = true;
            } else {
              item2.active = false;
            }
            majorList.push(item2);
            majorList.push(item2);
            item2.new_plan_group = item2.choose_code + item1.plan_group;
            choose_code = item2.choose_code;
          });
          item1.fail.map((item3) => {
            if (
              planSpeList.indexOf(item3.id) != -1 &&
              planGroupList.indexOf(
                scl_id + item3.choose_code + item3.plan_group
              ) != -1
            ) {
              item3.active = true;
            } else {
              item3.active = false;
            }
            majorList.push(item3);
            item3.new_plan_group = item3.choose_code + item1.plan_group;
            choose_code = item3.choose_code;
          });
          if (!planNewList[choose_code + item1.plan_group]) {
            planNewList[choose_code + item1.plan_group] = [];
          }
          planNewList[choose_code + item1.plan_group] = item1.pass.concat(
            item1.fail
          );
        });
        schoolNewList[index].specialList = specialList;
        schoolNewList[index].majorList = majorList;
        schoolNewList[index].planList = planNewList;
        this.schoolList = Object.assign([], schoolNewList);
      });
    },
    schoolDetailHandler(scl_id) {
      const { href } = this.$router.resolve({
        name: "school-detail",
        query: {
          scl_id: scl_id,
        },
      });
      window.open(href, "_blank");
    },
    draggableSchoolList(e, flag) {
      try {
        let index = 0;
        if (flag) {
          index = e;
        } else {
          index = e.target.dataset.index;
        }
        let activePlanArr = JSON.parse(localStorage.getItem("savePlanArr1"))[
          index
        ].plan_data;
        let activePlan = [...this.activePlanObj[index].plan_data];
        const activeNewPlan = activePlan.map((item, index) => {
          item.plan_type = activePlanArr[index].plan_type;
          return item;
        });
        this.$set(this.activePlanObj[index], "plan_data", activeNewPlan);
      } catch (error) {
        console.log(error);
      }
    },
    deleteSchoolhandler(school, index1, activeSchoolIndex) {
      const schoolList = this.schoolList;
      let count = this.activePlanObj[activeSchoolIndex].count;
      let indexSchool = index1;
      let deleteIndexSchool = this.planGroupList.indexOf(
        school.plan_scl.scl_id +
          school.plan_scl.choose_code +
          school.plan_scl.plan_group
      );
      let majorList = [];
      majorList = [...school.specialty_data];
      majorList.map((item) => {
        item.active = false;
        this.schoolList.map((scl) => {
          if (school.plan_scl.scl_id == scl.scl_id) {
            if (scl.specialList) {
              scl.specialList.map((group) => {
                group.pass.map((spe) => {
                  if (item.id == spe.id) {
                    spe.active = false;
                  }
                });
                group.fail.map((spe) => {
                  if (item.id == spe.id) {
                    spe.active = false;
                  }
                });
              });
            }
          }
        });
        let indexSpe = this.planSpeList.indexOf(item.id);
        if (indexSpe != -1) {
          this.planSpeList.splice(indexSpe, 1);
        }
        return item;
      });
      const findSchoolIndex = schoolList.findIndex(
        (item) =>
          item.scl_id ==
          school.plan_scl.scl_id +
            school.plan_scl.choose_code +
            school.plan_scl.plan_group
      );
      if (findSchoolIndex != -1) {
        const majorListArr = schoolList[findSchoolIndex].majorList;
        if (majorListArr) {
          majorListArr.map((item) => {
            item.active = false;
            return item;
          });
          schoolList[findSchoolIndex].majorList = majorListArr;
        }
      }
      if (deleteIndexSchool != -1) {
        this.planGroupList.splice(deleteIndexSchool, 1);
        // this.planSclList.splice(deleteIndexSchool, 1);
        count--;
      }

      let activePlan = this.activePlanObj[activeSchoolIndex].plan_data;

      let activePlanArr = JSON.parse(localStorage.getItem("savePlanArr1"))[
        activeSchoolIndex
      ].plan_data;

      activePlan[indexSchool].plan_scl = {};
      activePlan[indexSchool].specialty_data = [];

      const activeNewPlan = activePlan.filter(
        (item) => item.specialty_data.length != 0
      );
      const activeNewPlanArr = activePlanArr.map((item, index) => {
        if (activeNewPlan[index]) {
          item.plan_scl = activeNewPlan[index].plan_scl;
          item.specialty_data = activeNewPlan[index].specialty_data;
        }
        return item;
      });

      activePlan = [...activeNewPlan];
      this.$set(this.activePlanObj[activeSchoolIndex], "count", count);
      this.$set(
        this.activePlanObj[activeSchoolIndex],
        "plan_data",
        activeNewPlanArr
      );

      const countSum = [];
      let total_percent = 0;
      let count_tmp = 0;
      for (const i in this.activePlanObj) {
        const count = this.activePlanObj[i].count;
        let plan_data = this.activePlanObj[i].plan_data || [];

        if (plan_data.length > 0) {
          plan_data.map((item) => {
            if (item.specialty_data.length > 0) {
              item.specialty_data.map((item1) => {
                if (item1.percent) {
                  total_percent += item1.percent * 1;
                }
                count_tmp++;
              });
            }
          });
        }
        if (count) {
          countSum.push(count);
        }
      }
      this.activePlanObj.avg_percent = (total_percent / count_tmp).toFixed(0);
      if (countSum.length == 0) {
        this.zybStatus = false;
      }
      this.saveLocalStoragePlanHandler();
    },
    deleteMajorhandler(index, index1, index2, key, school, major) {
      const schoolList = [...this.schoolList];
      let deleteIndexSchool = schoolList.findIndex((item) => {
        return (
          item.scl_id + major.choose_code + major.plan_group ==
          school.plan_scl.scl_id +
            school.plan_scl.choose_code +
            school.plan_scl.plan_group
        );
      });
      if (deleteIndexSchool != -1 && schoolList[deleteIndexSchool].planList) {
        let majorList = [
          ...schoolList[deleteIndexSchool].planList[
            school.plan_scl.choose_code + school.plan_scl.plan_group
          ],
        ];
        let deleteIndexMajor = majorList.findIndex(
          (item) => item.id == major.id
        );
        if (deleteIndexMajor !== -1) {
          majorList[deleteIndexMajor].active = false;
        }
      }
      let planSpeList = this.planSpeList;
      let planGroupList = this.planGroupList;
      if (
        planSpeList.indexOf(major.id) != -1 &&
        planGroupList.indexOf(
          school.plan_scl.scl_id +
            school.plan_scl.choose_code +
            school.plan_scl.plan_group
        ) != -1
      ) {
        planSpeList.splice(
          planSpeList.findIndex((item) => item === major.id),
          1
        );
      }
      let specialty_data =
        this.savePlanObj[key].plan_data[index1].specialty_data;
      specialty_data.splice(index2, 1);
      if (specialty_data.length == 0) {
        this.savePlanObj[key].plan_data[index1].plan_scl = {};
        this.savePlanObj[key].count--;
      }
      this.activePlanObj[key] = this.savePlanObj[key];
      console.log(this.activePlanObj);
      const countSum = [];
      let total_percent = 0;
      let count_tmp = 0;
      for (const i in this.activePlanObj) {
        const count = this.activePlanObj[i].count;
        const plan_data = this.activePlanObj[i].plan_data;
        if (plan_data) {
          plan_data.map((item) => {
            if (item.specialty_data.length > 0) {
              item.specialty_data.map((item1) => {
                if (item1.percent) {
                  total_percent += item1.percent * 1;
                }
                count_tmp++;
              });
            }
          });
        }
        if (count) {
          countSum.push(count);
        }
      }
      if (countSum.length == 0) {
        this.zybStatus = false;
        this.activePlanObj.avg_percent = 0;
        localStorage.removeItem("savePlanData");
        return;
      }
      this.activePlanObj.avg_percent = (total_percent / count_tmp).toFixed(0);
      if (specialty_data.length == 0) {
        for (let i = index1; i < this.savePlanObj[key].plan_data.length; i++) {
          if (i == this.savePlanObj[key].plan_data.length - 1) {
            this.savePlanObj[key].plan_data[i].specialty_data = [];
            this.savePlanObj[key].plan_data[i].plan_scl = {};
            break;
          }
          let specialty_data =
            this.savePlanObj[key].plan_data[i + 1].specialty_data;
          let plan_scl = this.savePlanObj[key].plan_data[i + 1].plan_scl;
          this.savePlanObj[key].plan_data[i].specialty_data = specialty_data;
          this.savePlanObj[key].plan_data[i].plan_scl = plan_scl;
        }
      }
      this.saveLocalStoragePlanHandler();
    },
    activeVipHandler() {
      localStorage.setItem("isNewUser", "false");
      this.$store.commit("user/SHOWVIP", true);
    },
    removePlanHandler() {
      this.zybStatus = false;
      this.savePlanObj = JSON.parse(localStorage.getItem("removePlanObj"));
      this.activePlanObj = {};
      this.activeZybNames = [];
      this.activeDetNames = [];
      this.planSpeList = [];
      this.planGroupList = [];
      // this.planSclList = [];
      const schoolList = this.schoolList;
      const planNewList = {};
      schoolList.map((item) => {
        const majorList = item.majorList;
        if (majorList) {
          majorList.map((item1) => {
            item1.active = false;
            if (!planNewList[item1.choose_code + item1.plan_group]) {
              planNewList[item1.choose_code + item1.plan_group] = [];
            }
            planNewList[item1.choose_code + item1.plan_group].push(item1);
          });
        }
        item.planNewList = planNewList;
      });
      this.saveLocalStoragePlanHandler();
    },
    savePlanHandler() {
      if (this.has_code == 0) {
        this.$message({
          message: "您的账户暂未开通此功能",
          type: "warning",
        });
        return;
      }
      this.$store.commit("user/SHOWSAVEPLAN", true);
      let plan = { ...this.savePlanObj };
      const savePlanInfor = {};
      let total_percent = 0;
      let count_tmp = 0;
      for (const i in plan) {
        if (i != "avg_percent") {
          plan[i].batch_show = false;
          let plan_data = plan[i].plan_data;
          let findIndex = plan_data.findIndex(
            (item) => item.specialty_data.length > 0
          );
          if (findIndex != -1) {
            plan[i].is_plan = true;
          } else {
            plan[i].is_plan = false;
          }
          if (plan_data.length > 0) {
            plan_data.map((item) => {
              if (item.specialty_data.length > 0) {
                item.specialty_data.map((item1) => {
                  if (item1.percent) {
                    total_percent += item1.percent * 1;
                  }
                  count_tmp++;
                });
              }
            });
          }
        }
      }
      savePlanInfor.avg_percent = (total_percent / count_tmp).toFixed(0);
      let tmp = {};
      if (Object.keys(this.imitate_form).length > 0) {
        const plan_base_info = {
          subject_type: this.imitate_form.subject,
          exam_name: this.imitate_form.exam_name,
          exam_score: this.imitate_form.exam_score,
          score_adjust: this.imitate_form.adjust_score,
        };
        tmp = {
          plan_type: "1",
          plan_desc: this.imitate_form.subject + "/" + this.imitate_form.score,
          plan_base_info: plan_base_info,
        };
      } else {
        tmp = {
          plan_type: "0",
          plan_desc: this.gkInfor.subject + "/" + this.gkInfor.score,
          plan_base_info: {},
        };
      }
      Object.assign(tmp, this.gkInfor);
      Object.assign(savePlanInfor, tmp);
      savePlanInfor.json_str = this.savePlanObj;
      savePlanInfor.flag = this.imitate_form.flag || "";
      savePlanInfor.id = this.imitate_form.id || "";
      savePlanInfor.plan_title = this.imitate_form.plan_title || "";
      savePlanInfor.exam_name = this.imitate_form.exam_name || "";
      if (this.$route.query.title) {
        savePlanInfor.flag = "edit";
        savePlanInfor.plan_title = this.$route.query.title;
        savePlanInfor.id = this.$route.query.id;
      }
      this.$store.commit("user/EDITSAVEPLANINFOR", savePlanInfor);
    },
    changeSearchTypeHandler(index) {
      this.activeMoreIndex = index;
      this.valueMajor = "";
      this.valueSchool = "";
      this.valueJob = "";
    },
    hoverMenuHandler() {
      this.hoverMenuStatus = !this.hoverMenuStatus;
    },
    getSearchSchoolListHandler(query) {
      if (query == "") {
        return;
      }
      this.loading = true;
      getSearchSchoolList(query).then((res) => {
        this.loading = false;
        let list = [];
        list = res.data.map((item, index) => {
          return { value: `${item.scl_id}`, label: `${item.scl_name}` };
        });
        this.optionsSchool = list;
      });
    },
    geSearchSpecialListHandler(query) {
      if (query == "") {
        return;
      }
      this.loading = true;
      geSearchSpecialList(query).then((res) => {
        this.loading = false;
        let list = [];
        list = res.data.map((item, index) => {
          return { value: `${item.special_id}`, label: `${item.special_name}` };
        });
        this.optionsMajor = list;
      });
    },
    getSearchJobListHandler(query) {
      if (query == "") {
        return;
      }
      this.loading = true;
      getSearchJobList(query).then((res) => {
        this.loading = false;
        let list = [];
        list = res.data.map((item, index) => {
          return { value: `${item.job_code}`, label: `${item.job_name}` };
        });
        this.optionsJob = list;
      });
    },
    // planSmartHandler() {
    //     this.showPlanSmart = true
    // },
    // planSmartSubmitHandler() {
    //     this.savePlanObj = JSON.parse(localStorage.getItem("removePlanObj"));
    //     this.activePlanObj = {};
    //     this.activeZybNames = [];
    //     this.activeDetNames = [];
    //     this.planSpeList = [];
    //     this.planGroupList = [];
    //     let savePlan = Object.assign({}, this.savePlanObj[this.selectPatch.local_batch_type]);
    //     const schoolList = this.schoolList;
    //     let planSpeList = [];
    //     let planGroupList = [];
    //     schoolList.map(item => {
    //         const majorList = item.majorList;
    //         if (majorList) {
    //             majorList.map(item1 => {
    //                 item1.active = false;
    //             })
    //         }
    //     })
    //     const data = {
    //         score: this.gkInfor.score,
    //         local_type_id: this.gkInfor.local_type_id,
    //         local_batch_type: this.selectPatch.local_batch_type
    //     }
    //     planSmartSubmit(data).then(res => {
    //         this.showPlanSmart = false
    //         let sclTmp = res.data
    //         if(sclTmp.length === 0) {
    //             return
    //         }
    //         this.zybStatus = true
    //         sclTmp.map((item, index) => {
    //             savePlan.plan_data[index].plan_scl = item.scl_info
    //             const sclIndex = schoolList.findIndex(val => { return val.scl_id === item.scl_info.scl_id })
    //             item.specialty_data.map((item1,index1) => {
    //                 savePlan.plan_data[index].specialty_data[index1] = item1
    //                 if(sclIndex !== -1 && schoolList[sclIndex].majorList) {
    //                     const majorIndex = schoolList[sclIndex].majorList.findIndex(val => { return val.id === item1.id })
    //                     if(majorIndex !== -1) {
    //                         schoolList[sclIndex].majorList[majorIndex].active = true
    //                     }
    //                 }
    //                 planSpeList.push(item1.id);
    //             })
    //             planGroupList.push(item.scl_info.scl_id);
    //         })
    //         this.activeDetNames = [];
    //         this.activeZybNames = [];
    //         const count = savePlan.plan_data.filter(item => { return Object.keys(item.plan_scl).length != 0 });
    //         savePlan.count = count.length;
    //         this.planSpeList = Object.assign([], planSpeList);
    //         this.planGroupList = Object.assign([], planGroupList);
    //         this.$set(this.savePlanObj, this.selectPatch.local_batch_type, savePlan);
    //         this.savePlanArr = Object.assign([], savePlan.plan_data);
    //         for (const el in this.savePlanObj) {
    //             if (this.savePlanObj[el].count > 0) {
    //                 this.activePlanObj[el] = this.savePlanObj[el];
    //             }
    //         }
    //         // for (let index = 0; index < count; index++) {
    //         //     this.activeZybNames.push(index.toString())
    //         // }
    //         let total_percent = 0
    //         let count_tmp = 0
    //         for (const key in this.activePlanObj) {
    //             if (Object.hasOwnProperty.call(this.activePlanObj, key)) {
    //                 let value = this.activePlanObj[key].plan_data;
    //                 for (const key1 in value) {
    //                     if (Object.hasOwnProperty.call(value, key1)) {
    //                         if (value[key1].specialty_data.length > 0) {
    //                             value[key1].specialty_data.map(item => {
    //                                 if (item.percent) {
    //                                     total_percent += item.percent
    //                                 }
    //                                 count_tmp++
    //                             })
    //                             this.activeDetNames.push(value[key1].plan_scl.scl_id)
    //                         }
    //                     }
    //                 }
    //                 this.activeZybNames.push(key.toString())
    //             }
    //         }
    //         this.activePlanObj.avg_percent = (total_percent / count_tmp).toFixed(0)
    //     })
    // },
    updateZhiyuanHandler() {
      const data = this.imitate_form;
      const savePlan = JSON.parse(data.plan_info);
      let planSpeList = Object.assign([], this.planSpeList);
      let planGroupList = Object.assign([], this.planGroupList);
      // let planSclList = Object.assign([], this.planSclList);
      this.zybStatus = true;
      let total = 0;
      for (const key in savePlan) {
        if (savePlan.hasOwnProperty(key)) {
          const element = savePlan[key];
          element.count = 0;
          if (element.is_plan) {
            let count = 0;
            total++;
            element.plan_data.map((item) => {
              if (Object.keys(item.plan_scl).length > 0) {
                planGroupList.push(
                  item.plan_scl.scl_id +
                    item.plan_scl.choose_code +
                    item.plan_scl.plan_group
                );
                // planSclList.push(item.plan_scl.scl_id);
                count++;
                if (item.specialty_data.length > 0) {
                  this.activeDetNames.push(
                    item.plan_scl.scl_id +
                      item.plan_scl.choose_code +
                      item.plan_scl.plan_group
                  );
                  item.specialty_data.map((item1) => {
                    planSpeList.push(item1.id);
                  });
                }
              }
            });
            element.count = count;
            this.activeZybNames.push(key.toString());
            this.activePlanObj[key] = element;
          }
        }
      }
      this.planSpeList = Object.assign([], planSpeList);
      this.planGroupList = Object.assign([], planGroupList);
      // this.planSclList = Object.assign([], planSclList);
      this.activePlanObj.avg_percent = data.avg_percent;
      this.savePlanObj = savePlan;
      // localStorage.setItem("removePlanObj", JSON.stringify(this.savePlanObj));
    },
    clickHandler(item) {
      if (!item.special_id) {
        this.$message({
          message: "暂无相关专业信息",
          type: "warning",
        });
        return;
      }
      this.$router.push({
        path: "/majorDetail",
        query: {
          special_id: item.special_id,
        },
      });
    },
    getMyPlanDetailHandler(id) {
      getMyPlanDetail(id).then((res) => {
        const data = res.data;
        let planObj = { ...res.data };
        let zyObj = data.plan_desc.split("/");
        planObj.subject = zyObj[0];
        planObj.score = zyObj[1];
        let plan_info = { ...JSON.parse(data.plan_info) };
        planObj.plan_info = { ...plan_info };
        this.planDetailObj = planObj;
        var planSpeList = [];
        var planGroupList = [];
        var activeZybNames = [];
        for (const key in plan_info) {
          if (key != "avg_percent") {
            var plan = plan_info[key].plan_data;
            plan.forEach((val) => {
              if (val.specialty_data.length != 0) {
                activeZybNames.push(key);
                var id =
                  val.plan_scl.scl_id +
                  val.specialty_data[0].choose_code +
                  val.specialty_data[0].plan_group;
                planGroupList.push(id);
                val.specialty_data.forEach((spe) => {
                  planSpeList.push(spe.id);
                });
              }
            });
          }
        }
        this.planSpeList = planSpeList;
        this.planGroupList = planGroupList;
        this.activePlanObj = this.planDetailObj.plan_info;
        this.activePlanObj.avg_percent = this.planDetailObj.avg_percent;
        this.savePlanObj = this.planDetailObj.plan_info;
        this.activeDetNames = planGroupList;
        this.activeZybNames = activeZybNames;
        this.zybStatus = true;
      });
    },
    // 往年相似专业
    getSpecialScore(id) {
      this.loading = true;
      getSpecialListById(id).then((res) => {
        this.loading = false;
        console.log(res.data);
        this.special_score = res.data;
        this.specialScoreVisible = true;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/variables.scss";

.zy-img {
  @include gwidth;
  margin-top: 10px;
}

.zy-school {
  @include gwidth;

  .el-col-7 {
    width: 32.5%;
  }

  .el-col-16 {
    position: relative;
    padding-right: 10px;
  }
}

.rank-box {
  border: none;
  background: #fff;
  box-shadow: none !important;
  padding-top: 24px;
  border-radius: 0 10px 10px 10px;
  padding: 24px;
}

.zy-text {
  color: #2c2e33;
  position: absolute;
  top: 8px;
  right: 28px;
  z-index: 99;
  font-size: 14px;
  cursor: pointer;

  span {
    width: 1px;
    height: 14px;
    background: #c4c7cc;
    border-radius: 1px;
    display: inline-block;
    margin: 0px 3px;
    position: relative;
    top: 1px;
  }

  a {
    color: $common-color;
  }

  .el-icon-arrow-down,
  .el-icon-arrow-up {
    margin-right: 20px;
  }

  .el-icon--right {
    margin-left: -3px;
  }

  .con-score-span {
    position: absolute;
    display: inline-block;
    right: -22px;
    width: 28px;
    height: 28px;
    background: #ffffff;
    border-radius: 4px;
    box-shadow: 0px 1px 2px 0px rgba(44, 46, 51, 0.1);
  }

  .con-score-section {
    font-size: 12px;
    font-weight: 400;
    color: #909399;
    margin-top: 6px;
    position: relative;
    left: -22px;
  }

  .con-score-span img {
    width: 14px;
    height: 14px;
    position: relative;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}

.province-list {
  @include gflex;
  font-size: 0;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 6px;

  .title-box {
    width: 78px;
    font-size: 14px;
    text-align: right;
    color: #909399;
    margin-top: 3px;
  }

  a {
    display: inline-block;
    font-size: 14px;
    color: #5e6166;
    cursor: pointer;
    text-align: center;
    margin-bottom: 10px;
    padding: 3px 5px;
  }

  a:not(:nth-child(13n)) {
    margin-right: 12px;
  }

  .active-tag {
    color: #ffffff !important;
    background: $common-color;
    border-radius: 4px;
  }

  a:hover {
    color: $common-color;
  }

  .province-name {
    @include gflex;
    width: calc(100% - 4px);
    justify-content: flex-start;
    flex-wrap: wrap;
  }
}

.choice-box {
  font-size: 14px;
  margin-top: 4px;
  color: $common-color;
  cursor: pointer;

  i {
    margin-left: 5px;
  }
}

.collapse-box {
  width: 100%;
  font-size: 0;

  img,
  .el-image {
    width: 64px;
    height: 64px;
    margin-top: 5px;
  }

  .el-col-3 {
    width: 11%;
  }

  > .el-col-4 {
    float: right;
  }

  .zytb-school-name {
    font-size: 18px;
    font-weight: 600;
    color: #2c2e33;
    margin-bottom: 5px;
  }
  .zytb-school-name span:nth-child(2) {
    margin-left: 10px;
    font-size: 12px;
    padding: 4px;
    background-color: #F0F2F5;
    color: #909399;
    border-radius: 8px;
  }
  .zytb-school-name span:last-child {
    margin-left: 10px;
    font-size: 12px;
    padding: 4px;
    background-color: #ff2929;
    color: #fff;
    border-radius: 8px;
  }
  .zytb-school-tag span {
    display: inline-block;
    padding: 3px 8px;
    font-size: 12px;
    color: #909399;
    height: 22px;
    background: #f0f2f5;
    border-radius: 4px;
    line-height: 22px;
    margin-right: 4px;
  }

  .zytb-school-count {
    margin-top: -3px;
    width: 100%;
    // 给内部每一行div设置flex换行
  > div {
    display: flex;
    // flex-wrap: wrap;
    align-items: center;
    gap: 4px 12px; // 行间距4px，列间距12px，统一控制间距
    line-height: 20px; // 统一行高，避免高低错落
    margin-bottom: 6px; // 行与行之间的间隔
    span{
      background: #ffffff!important;
      color: #909399!important;
    }
    &:last-child {
      margin-bottom: 0;
    }
  }

  span {
    margin-right: 0; // 去掉原来的margin-right，改用gap控制
    font-size: 12px;
    color: #909399;
    font-weight: 400;
    white-space: nowrap; // 单个信息项内部不换行，保持完整性
  }
  }

  .zytb-school-count-diff {
    position: relative;
    top: 14px;
  }

  .zytb-school-count span {
    font-size: 12px;
    color: #909399;
    margin-right: 12px;
    font-weight: 400;
  }

  .zytb-school-fx-1 {
    background: #fe9f0a;

    span {
      color: #fe9f0a;
    }
  }
  .zytb-school-fx-red {
    background: #ff2929;

    span {
      color: #ff2929;
    }
  }
  .zytb-school-fx-2 {
    background: #3272ff;
    padding-bottom: 7px;

    span {
      color: #3272ff;
    }
  }

  .zytb-school-fx-3 {
    background: #139b83;
    padding-bottom: 7px;

    span {
      color: #139b83;
    }
  }

  .zytb-school-fx {
    width: 117px;
    height: 61px;
    border-radius: 4px;
    font-size: 12px;
    text-align: center;
    padding: 2px;
    box-sizing: border-box;
    float: right;
    display: flex;
    color: #ffffff;

    .zytb-school-tj {
      background: #ffffff;
      width: 55px;
      height: 57px;
      background: #ffffff;
      border-radius: 2px;
      box-sizing: border-box;

      div {
        color: #909399;
        font-size: 12px;
      }
    }

    .zytb-school-ms {
      padding-left: 6px;
      // line-height: 18px;
      // display: flex;
      // align-items: center;
      div {
        font-size: 16px;
      }
    }

    span {
      font-size: 24px;
    }

    .zytb-school-fx-span {
      font-size: 14px;
    }
  }

  .zytb-school-major {
    color: $common-color;
    font-size: 14px;
    margin-top: 12px;
    position: relative;
    right: 28px;
    text-align: right;
  }
}

.collapse-box-diff {
  padding: 0 10px;
  .el-col-18 {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 75%;
    width: auto;
  }

  > .el-col-4 {
    width: 10%;
  }

  > .el-col-20 {
    width: 87%;
  }
  .zytb-school-name {
    > .el-col-4 {
      width: 15%;
    }
    > .el-col-20 {
      width: 85%;
    }
  }
  .zytb-school-name .el-col-4 > span {
    display: inline-block;
    // padding: 0px 0px 5px 0px;
    font-size: 16px;
    color: $common-color;
    width: 64px;
    height: 46px;
    background: #f5f7fa;
    border-radius: 4px;
    margin-left: 4px;
    text-align: center;
    box-sizing: border-box;

    div {
      font-size: 12px;
      color: #999390;
      margin-top: -5px;
    }
  }

  button {
    min-width: 86px;
    height: 30px;
    line-height: 26px;
    border: 1px solid $common-color;
    border-radius: 5px;
    color: $common-color;
    text-align: center;
    background-color: #fff;
    font-size: 14px;
    float: right;
    margin-top: 26px;
    position: relative;

    img {
      width: 14px;
      height: 14px;
      top: 2px;
      left: 13px;
      position: absolute;
    }
  }

  .zytb-school-btn {
    background: $common-color !important;
    color: #fff !important;
    text-align: right;
    padding-right: 8px;
  }
}

.collapse-box-diff:not(:last-child) {
  margin-bottom: 24px;
}

.zy-active {
  font-size: 16px;
  width: 100%;
  height: 152px;
  text-align: center;
  position: absolute;
  bottom: 24px;
  left: 0;

  p {
    margin-top: 33px;
  }

  span {
    display: inline-block;
    color: #ff861d;
  }

  button {
    width: 96px;
    height: 40px;
    border: none;
    background: linear-gradient(133deg, #ffce5d 1%, #ffa02f 97%, #ffa02f 97%);
    border-radius: 5px;
    color: #ffffff;
    margin-top: 10px;
  }
}

.zyb-box {
  position: relative;
  right: 0;
  // top: 72px;
  margin-bottom: 20px;
  height: 622px;

  .zyb-title {
    height: 56px;
    border-bottom: 1px solid #f0f2f5;
  }

  .zyb-avg-percent {
    height: 32px;
    background: #f5f7fa;
    border-radius: 4px;
    font-size: 14px;
    color: #909399;
    line-height: 32px;
    margin-top: 8px;
    padding: 0 12px;
    span {
      color: $common_color;
    }
  }

  .no-data-box {
    margin-top: 0;
  }

  .zyb-img {
    width: 24px;
    height: 24px;
    position: relative;
    top: 4px;
  }

  .el-col-20 {
    color: #2c2e33;
    font-size: 22px;
    font-weight: 600;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .el-col-4 {
    color: $common-color;
    font-size: 16px;
    text-align: right;
    line-height: 22px;
    cursor: pointer;
    margin-top: 4px;
  }

  .zyb-major {
    position: relative;

    .zy-type {
      color: $common-color;
      font-weight: 600;
      font-size: 20px;
      width: 48px;
      height: 50px;
      background: #f5f7fa;
      border-radius: 4px;
      text-align: center;
      padding-top: 4px;
      box-sizing: border-box;
      margin-top: -4px;

      div {
        font-size: 12px;
      }
    }

    .el-col-20 {
      color: $common-color;
      font-size: 16px;
      font-weight: 400;
    }

    .tzy-collapse-item {
      .el-col-1 {
        text-align: right;
        width: 7%;
      }
    }

    img {
      width: 10px;
      height: 10px;
    }
  }

  button {
    color: #ffffff;
    font-size: 18px;
    width: 100%;
    height: 52px;
    background: linear-gradient(90deg, #ffa94a, #ff913c);
    border-radius: 0px 0px 10px 10px;
    position: relative;
    bottom: 52px;
    border: 1px solid #ffa94a;
  }
  // .add-zyb-btn {
  //     display: flex;
  //     button {
  //         width: 50%;
  //         margin: 0;
  //     }
  //     button:first-child {
  //         border-radius: 0px 0px 0px 10px;
  //         background: linear-gradient(270deg, #4c93ff, #4a9eff 99%);
  //         border: 1px solid #4a9eff;
  //     }
  //     button:last-child {
  //         border-radius: 0px 0px 10px 0px;
  //     }
  // }
}

.el-menu {
  width: 260px !important;
  background: #ffffff;
  border-radius: 6px;
  box-shadow: 0px 1px 6px 0px rgba(51, 55, 61, 0.2);
  padding: 0 12px;
  box-sizing: border-box;
  position: absolute;
  right: 20px;
  margin-top: -14px;
  z-index: 999;
  -webkit-transition: -webkit-transform 0.1s cubic-bezier(0.165, 0.84, 0.44, 1);
  transition: transform 0.1s cubic-bezier(0.165, 0.84, 0.44, 1);
  text-align: center;

  li {
    color: #2c2e33;
    font-size: 14px;
    height: 44px;
    line-height: 44px;
    @include gflex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #f0f2f5;

    img {
      width: 20px;
      height: 20px;
    }
  }

  // li:not(:last-child) {
  //     border-bottom: 1px solid #f0f2f5;
  // }

  .major-patch {
    color: #c4c7cc;
  }

  .major-patch-bkx {
    color: #909399;
  }
}

.no-data-box {
  text-align: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  margin-top: 80px;

  img {
    width: 110px;
    height: 110px;
  }

  p {
    font-size: 16px;
    text-align: center;
    color: #abaeb3;
  }
}

.no-data-box-diff {
  top: 70%;
}

.no-data-content {
  border-bottom: 1px solid #f0f2f5;
  padding-bottom: 24px;
}

.zyb-draggable {
  margin: 0;
  padding: 0;
}

.el-item-diff {
  -webkit-filter: blur(15px);
  -moz-filter: blur(15px);
  -o-filter: blur(15px);
  -ms-filter: blur(15px);
  filter: blur(15px);
}

.zyb-major-infor {
  span {
    display: inline-block;
  }

  .zyb-major-title {
    font-size: 14px;
    color: #2c2e33;
    font-weight: 400;
    width: 80%;
    display: inline-block;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    -o-text-overflow: ellipsis;
  }

  .zyb-major-delete {
    color: #ee4444;
    font-size: 14px;
    float: right;
    cursor: pointer;
  }
}

.zyb-major-percent {
  font-size: 12px;
  color: #999390;
  line-height: 17px;
  span {
    color: $common_color;
  }
}

.fixed-top {
  position: fixed;
  top: -16px;
  right: calc(50% - 592px);
  width: 384px !important;
}

@media screen and (max-width: 1280px) {
  .fixed-top {
    position: fixed;
    top: -16px;
    right: 0;
    width: 384px !important;
  }
}

.zyb-bar {
  height: 500px;
  width: calc(100%);
}

.el-col-22 {
  width: 91%;
}
.zyb-batch ::v-deep .el-collapse-item__arrow {
  top: 25px;
}
.zyb-batch-diff {
  width: 95%;
}

.zyb-batch-diff1 {
  width: 98.7%;
}

.zy-search {
  width: 100%;
  height: 44px;
  background: #ffffff;
  border: 1px solid #e1e4eb;
  border-radius: 8px;
  margin-bottom: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;

  img {
    position: absolute;
    right: 10px;
    top: 5px;
    cursor: pointer;
  }

  .el-col-4 {
    width: 74px;
    border-right: 1px solid #e1e4eb;
    color: #66605e;
    font-size: 16px;
    position: relative;
    cursor: pointer;
    height: 30px;
    // line-height: 30px;

    span {
      margin-left: 4px;
      color: #c4c7cc;
    }

    .el-icon-arrow-up {
      color: $common-color;
    }
  }
}

.menu-tools-ul {
  position: absolute;
  height: auto;
  min-width: 80px;
  padding: 10px;
  z-index: 9999;
  color: #5e6166;
  font-size: 16px;
  font-weight: 400;
  text-align: center;
  line-height: 35px;
  box-sizing: border-box;
  left: -16px;
  top: 36px;
  margin-top: -8px;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 10px;
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(6px);

  .menu-li {
    color: #332e2c !important;
    font-size: 18px;
    font-weight: 600;
  }

  li {
    padding: 0;
    list-style: none;
    cursor: pointer;
  }

  li:hover {
    color: $common-color;
  }
}
.dialog-box {
  img {
    width: 24px;
    height: 24px;
    position: absolute;
    right: 40px;
    top: 40px;
    z-index: 999;
  }
  p {
    margin: 40px 0;
    color: #5e6166;
    font-size: 16px;
    position: relative;
    z-index: 9999;
    text-align: left;
    margin: 0;
    line-height: 30px;
  }
  .dialog-footer {
    padding: 0;
    button {
      width: 240px;
      height: 52px;
      border-radius: 8px;
      font-size: 18px !important;
      border: none;
      margin-bottom: 30px;
      top: 40px;
    }
    .vip-btn1 {
      background: #e1e4eb !important;
      color: #5e6166 !important;
      background: #e1e4eb !important;
      position: relative;
      left: -10px;
    }
    .vip-btn2 {
      background: linear-gradient(90deg, #ffa94a, #ff913c) !important;
      color: #ffffff !important;
      position: relative;
      right: -10px;
    }
  }
}
.plan-box {
  height: 32px;
  background: #f5f7fa;
  border-radius: 4px;
  font-size: 14px;
  color: $common-color;
  line-height: 32px;
  padding: 0 12px;
  margin-bottom: 16px;
  font-weight: 400px;
}
::v-deep.cascader-diff {
  justify-content: start;
  .el-cascader {
    position: relative;
    top: -8px;
  }
  input {
    height: 36px !important;
    border: 1px solid #e1e4eb !important;
    border-radius: 4px;
    font-size: 14px;
  }
  .el-input__suffix {
    right: 10px;
  }
  .title-box {
    position: relative;
    left: 1px;
    width: 70px;
  }
  input::placeholder {
    font-size: 14px !important;
  }
}
.spe_title_pass {
  width: 168px;
  height: 30px;
  line-height: 30px;
  padding: 0 12px;
  font-weight: bold;
  text-align: left;
  color: #ffffff;
  font-size: 14px;
  background: url("../../assets/images/special1.png") no-repeat;
  background-size: 100%;
  margin: 24px 0 6px;
}
.spe_title_fail {
  width: 268px;
  height: 30px;
  line-height: 30px;
  padding: 0 12px;
  font-weight: bold;
  text-align: left;
  color: #ffffff;
  font-size: 14px;
  background: url("../../assets/images/special2.png") no-repeat;
  background-size: 100%;
  margin: 24px 0 6px;
}
::v-deep .el-collapse-item__arrow {
  top: 120px;
}
</style>
